import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import axios from 'axios';
import { useNavigate,useLocation } from 'react-router-dom';
import { showLoading } from 'react-global-loading';
import { toast, ToastContainer } from 'react-toastify';
import { isNumeric } from '../../../../Custom/Custom';
import messages from '../../../../assets/Messages.json';
import asiTitle from '../../../../asi.json';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import { API_URL } from '../../../../Constant';
import Remarks__list from './Remarks__list';
import Remarks2, { validateRemarks2Section } from './Remarks2';
import StatusUnitDropdown from '../../../../Components/Block/StatusUnitDropdown';
import IndustryCodeReturnDropdown from '../../../../Components/Block/IndustryCodeReturnDropdown';
import { markPageAsSaved, PAGE_NAMES, refreshBalanceSheetValidation, clearSavedPages } from '../../../../Components/BalanceSheet/BalanceSheetHeader';
import { filterRemarksList } from '../../../../Custom/Custom';
import { getStaticBlockPayload } from './getStaticBlockPayload';
import { getAuthHeaders, getUserClaimsForUi, hasAuthSession } from '../../../../utils/authStorage';
import { validateFileForUpload } from '../../../../utils/fileValidation';

const BLOCK_A_ITEM_NAMES = [
  '1. DSL No.',
  '2. PSL No.',
  '3. Scheme',
  '4. Industry code as per Frame',
  '5. Industry code as per Return',
  '6. Description of Industry',
  '7. State/UT master',
  '8. District',
  '9. Sector',
  '10. RO / SRO Code',
  '11. No. of Units',
  '12. Status of Unit'
];
const BLOCK_B_ITEM_NAMES = [
  '1. Particulars of the factory',
  '2. Type of organisation',
  '3. CIN',
  '4. Whether the unit has ISO Certification, 14000 Series',
  '5. Year of initial production',
  '6. Accounting Year',
  '7. No of months operation',
  '8. Whether the share capital of the company includes share of foreign entities (Yes-1, No-2)',
  '9. Any RD unit in your factory (Yes registered with DST/DBT-1, Yes registered with others-2, no-3)',
  '10. Details of contact person',
  '11. Whether the unit offered any formal training?',
  '12. Goods and Services Tax Identification Number (GSTIN)'
];

function BalanceSheet() {
  const navigate = useNavigate();


  const [formData, setFormData] = useState({
    year: '',
    scheduleDespatchNo: '',
    pslNo: '',
    schemeCode: '',
    industryCodeFrame: '',
    industryCodeReturn: '',
    descriptionOfIndustry: '',
    state: '',
    stateCode: '',
    district: '',
    sector: '',
    roSroCode: '',
    numberOfUnits: '',
    statusOfUnit: '',
    nameUnit: '',
    addressUnit: '',
    villTown: '',
    districtName: '',
    stateName: '',
    pinCode: '',
    emailId: '',
    mobileNumber: '',
    typeOfOrg: '',
    hasCIN: '',
    cin: '',
    isoCert: '',
    yearOfInitialProd: '',
    accountingYearFrom: '',
    accountingYearTo: '',
    monthsOfOperation: '',
    shareCapital: '',
    rdUnit: '',
    rdMaleEmployees: '',
    rdFemaleEmployees: '',
    rdTransgenderEmployees: '',
    contactName: '',
    contactTele: '',
    contactFax: '',
    contactEmail: '',
    contactPersonName: '',
    contactPersonDesignation: '',
    contactPersonEmail: '',
    contactPersonMobile: '',
    formalTraining: '',
    trainingMaleEmployees: '',
    trainingFemaleEmployees: '',
    trainingTransgenderEmployees: '',
    gstin: '',
    dslNo: '',
    verificationCompilationDate: '',
    entryMode: 'balanceSheet',
    documentPath: '',
    documentPathFull: '',
    uploadScheduleFileName: '',
    uploadScheduleFilePath: '',
    remarksBlock: '',
    remarksItems: '',
    remarks: '',
  });

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [verificationDate, setVerificationDate] = useState(null);
  const today = new Date();

  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadScheduleFile, setUploadScheduleFile] = useState(null);

  const [errors, setErrors] = useState({
    contactEmail: '',
    cin: ''
  });

  const [isApiLoading, setIsApiLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const apiCallRef = useRef(null);
  const lastApiCallRef = useRef({ dslNo: '', year: '' });
  const descriptionRef = useRef(null);
  const toastShownRef = useRef({});
  const buttonClickRef = useRef({ isProcessing: false });

  const [industryCodeReturnList, setIndustryCodeReturnList] = useState([]);
  const [unitCodes, setUnitCodes] = useState([]);
  const [remarksList, setRemarksList] = useState([]);
  const location = useLocation();
  
  useEffect(() => {
    const currentPath = location.pathname;
    console.log('currentPath===>', currentPath);
  }, [location.pathname]);

  const getUserInfo = useCallback(() => {
    try {
      const decoded = getUserClaimsForUi();
      if (decoded) {
        return decoded.id || decoded;
      }
    } catch (error) {
      console.error('Error decoding token:', error);
    }
    return null;
  }, []);

  const autoResizeDescription = useCallback(() => {
    const textarea = descriptionRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, []);

  const validateEmail = useCallback((email) => {
    if (!email || email.trim() === '') {
      return '';
    }

    if (email.length > 55) {
      return 'Email must not exceed 55 characters';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return 'Please enter a valid email address';
    }

    return '';
  }, []);

  const validateCIN = useCallback((cin) => {
    if (!cin || cin.trim() === '') {
      return ''; // CIN is optional
    }


    return '';
  }, []);

  const formatDateDDMMYYYY = useCallback((date = new Date()) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }, []);

  const getConfig = useCallback(() => {
    return { ...getAuthHeaders(), withCredentials: true };
  }, []);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;

    if (name === "dslNo") {
      const userInfo = getUserInfo();
      if (userInfo && userInfo.ROLE_CODE === 'FACTO') {
        return;
      }

      if (value === "" || isNumeric(value)) {
        if (value === "") {
          console.log('DSL cleared, resetting all fields');
          setFormData({
            year: '',
            scheduleDespatchNo: '',
            pslNo: '',
            schemeCode: '',
            industryCodeFrame: '',
            industryCodeReturn: '',
            descriptionOfIndustry: '',
            state: '',
            stateCode: '',
            district: '',
            sector: '',
            roSroCode: '',
            numberOfUnits: '',
            statusOfUnit: '',
            nameUnit: '',
            addressUnit: '',
            villTown: '',
            districtName: '',
            stateName: '',
            pinCode: '',
            emailId: '',
            mobileNumber: '',
            typeOfOrg: '',
            hasCIN: '',
            cin: '',
            isoCert: '',
            yearOfInitialProd: '',
            accountingYearFrom: '',
            accountingYearTo: '',
            monthsOfOperation: '',
            shareCapital: '',
            rdUnit: '',
            rdMaleEmployees: '',
            rdFemaleEmployees: '',
            rdTransgenderEmployees: '',
            contactName: '',
            contactTele: '',
            contactFax: '',
            contactEmail: '',
            contactPersonName: '',
            contactPersonDesignation: '',
            contactPersonEmail: '',
            contactPersonMobile: '',
            formalTraining: '',
            trainingMaleEmployees: '',
            trainingFemaleEmployees: '',
            trainingTransgenderEmployees: '',
            gstin: '',
            dslNo: '',
          });

          setStartDate(null);
          setEndDate(null);

          setUploadedFile(null);
          setUploadScheduleFile(null);
          setFormData(prev => ({ ...prev, uploadScheduleFileName: '' }));

          setIsDataLoaded(false);
          setIsApiLoading(false);
          setIsFirstLoad(false);
          lastApiCallRef.current = { dslNo: '', year: '' };
          setErrors({ contactEmail: '', cin: '' });

          clearSavedPages();
          localStorage.removeItem('balanceSheetFormData');
          localStorage.removeItem('balanceSheetDslYear');
          window.dispatchEvent(new CustomEvent('refreshBalanceSheetHeader'));

          console.log('✅ Reset completed - isFirstLoad set to false, ready for new API calls');
        } else {
          console.log('📝 DSL No. updated to:', value);
          setFormData(prev => ({ ...prev, [name]: value }));
          setIsDataLoaded(false);
          lastApiCallRef.current = { dslNo: '', year: '' };
          setErrors({ contactEmail: '', cin: '' });

          console.log('🔄 States reset - ready for API call when year is selected');
        }
      }
      return;
    }

    const numericEmployeeFields = ['rdMaleEmployees', 'rdFemaleEmployees', 'rdTransgenderEmployees',
      'trainingMaleEmployees', 'trainingFemaleEmployees', 'trainingTransgenderEmployees'];
    if (numericEmployeeFields.includes(name)) {
      if (value && !/^\d*$/.test(value)) {
        toast.error('Please enter numeric value only.', messages.COLOR_RED);
        return;
      }
      if (value.length > 6) {
        const sanitizedValue = value.substring(0, 6);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    if (name === 'monthsOfOperation') {
      if (value && !/^\d*$/.test(value)) {
        toast.error('Please enter numeric value only.', messages.COLOR_RED);
        return;
      }
      if (value.length > 2) {
        const sanitizedValue = value.substring(0, 2);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    if (name === "pinCode") {
      if (value && !/^\d*$/.test(value)) {
        toast.error('PIN Code should be numeric only.', messages.COLOR_RED);
        return;
      }
      if (value.length > 6) {
        const sanitizedValue = value.substring(0, 6);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    const mobileFields = ['contactPersonMobile', 'mobileNumber'];
    if (mobileFields.includes(name)) {
      if (value && !/^\d*$/.test(value)) {
        toast.error('Mobile number should be numeric only.', messages.COLOR_RED);
        return;
      }
      if (value.length > 10) {
        const sanitizedValue = value.substring(0, 10);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    if (name === 'stateCode') {
      if (value && !/^\d*$/.test(value)) {
        toast.error('State Code should be numeric only.', messages.COLOR_RED);
        return;
      }
      if (value.length > 5) {
        const sanitizedValue = value.substring(0, 5);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    if (name === 'yearOfInitialProd') {
      if (value && !/^\d*$/.test(value)) {
        toast.error('Entry only number', messages.COLOR_RED);
        return;
      }
      if (value.length > 4) {
        const sanitizedValue = value.substring(0, 4);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    if (name === 'accountingYearFrom' || name === 'accountingYearTo') {
      if (value && !/^[0-9/]*$/.test(value)) {
        toast.error('Enter number value only', messages.COLOR_RED);
        return;
      }

      let digitsOnly = value.replace(/\//g, '');
      let formattedValue = '';
      if (digitsOnly.length <= 2) {
        formattedValue = digitsOnly;
      } else if (digitsOnly.length <= 4) {
        formattedValue = digitsOnly.substring(0, 2) + '/' + digitsOnly.substring(2, 4);
      } else {
        formattedValue = digitsOnly.substring(0, 2) + '/' + digitsOnly.substring(2, 4);
      }

      if (formattedValue.length > 5) {
        formattedValue = formattedValue.substring(0, 5);
      }

      setFormData(prev => ({ ...prev, [name]: formattedValue }));
      return;
    }

    if (name === 'industryCodeReturn') {
      if (value && !/^\d*$/.test(value)) {
        toast.error('Industry Code Per Return should be numeric only.', messages.COLOR_RED);
        return;
      }
      if (value.length > 5) {
        const sanitizedValue = value.substring(0, 5);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }

      const codeValue = value ? String(value).trim() : '';
      if (codeValue && codeValue.length === 5) {
        setTimeout(() => {
          const fetchDescription = async () => {
            try {
              showLoading(true);
              const response = await axios.get(
                `${API_URL}api/asi/nicIndustryMaster?niccode=${codeValue}`,
                getConfig()
              );

              if (response.data && response.data.status && response.data.data && response.data.data.length > 0) {
                const nicDescription = response.data.data[0].nicDescription || '';
                setFormData(prev => ({
                  ...prev,
                  descriptionOfIndustry: nicDescription
                }));
              } else {
                if (response.data && response.data.status === false && response.data.message) {
                  toast.error(response.data.message, messages.COLOR_RED);
                }
                setFormData(prev => ({
                  ...prev,
                  descriptionOfIndustry: ''
                }));
              }
            } catch (error) {
              console.error('Error fetching NIC Industry Description:', error);
              setFormData(prev => ({
                ...prev,
                descriptionOfIndustry: ''
              }));
              toast.error('NIC Industry code not found', messages.COLOR_RED);
            } finally {
              showLoading(false);
            }
          };
          fetchDescription();
        }, 100);
      } else if (codeValue === '') {
        setFormData(prev => ({ ...prev, descriptionOfIndustry: '' }));
      }
    }

    const textFields = ['villTown', 'districtName', 'stateName', 'contactPersonName', 'contactPersonDesignation', 'nameUnit'];
    if (textFields.includes(name)) {
      const textOnlyValue = value.replace(/[^a-zA-Z\s\.\-\'\(\)]/g, '');
      if (value !== textOnlyValue) {
        toast.error(`${name === 'contactPersonName' ? 'Name' : name === 'contactPersonDesignation' ? 'Designation' : 'Field'} should contain only letters, spaces, dots, and hyphens.`, messages.COLOR_RED);
        return;
      }
      if (value.length > 100) {
        const sanitizedValue = value.substring(0, 100);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    const emailFields = ['emailId', 'contactPersonEmail'];
    if (emailFields.includes(name)) {
      const is2024Year = !formData.year || formData.year.startsWith('2024');
      const maxLength = is2024Year ? 100 : 55;
      if (value && value.length > maxLength) {
        const sanitizedValue = value.substring(0, maxLength);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    if (name === 'gstin') {
      const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, '');
      if (value !== alphanumericValue) {
        toast.error('GSTIN should contain only alphanumeric characters.', messages.COLOR_RED);
        return;
      }
      if (value.length > 15) {
        const sanitizedValue = value.substring(0, 15);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    if (name === 'cin') {
      const is2024Year = !formData.year || formData.year.startsWith('2024');
      const maxLength = is2024Year ? 21 : 25;
      const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, '');
      if (value !== alphanumericValue) {
        toast.error('CIN should contain only alphanumeric characters.', messages.COLOR_RED);
        return;
      }
      if (value.length > maxLength) {
        const sanitizedValue = value.substring(0, maxLength);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    if (name === 'descriptionOfIndustry') {
      const is2024Year = !formData.year || formData.year.startsWith('2024');
      const maxLength = is2024Year ? 200 : 500;
      if (value.length > maxLength) {
        const sanitizedValue = value.substring(0, maxLength);
        setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
        return;
      }
    }

    if (name === "contactEmail") {
      const emailError = validateEmail(value);
      setErrors(prev => ({ ...prev, contactEmail: emailError }));
      setFormData(prev => ({ ...prev, [name]: value }));
      return;
    }

    if (name === "contactName") {
      const textOnlyValue = value.replace(/[^a-zA-Z\s\.\-]/g, '');

      if (value !== textOnlyValue) {
        toast.error('Name and Designation should contain only letters, spaces, dots, and hyphens', messages.COLOR_RED);
        return;
      }

      if (textOnlyValue.length > 100) {
        toast.error('Name and Designation should not exceed 100 characters', messages.COLOR_RED);
        return;
      }

      setFormData(prev => ({ ...prev, [name]: textOnlyValue }));
      return;
    }

    setFormData(prev => ({ ...prev, [name]: value }));

    if (name === 'statusOfUnit') {
      try {
        localStorage.setItem('statusUnitCode', String(value || ''));
      } catch (e) { /* ignore */ }
    }

    if (name === 'descriptionOfIndustry') {
      requestAnimationFrame(() => autoResizeDescription());
    }

    if (name === "year") {
      const userInfo = getUserInfo();
      if (userInfo && userInfo.ROLE_CODE === 'FACTO' && userInfo.USER_ID) {
        const expectedDSL = String(userInfo.USER_ID).trim();
        const currentDSL = String(formData.dslNo).trim();

        if (currentDSL && currentDSL !== expectedDSL) {
          toast.error('Invalid DSL No.', messages.COLOR_RED);
          setFormData(prev => ({ ...prev, dslNo: expectedDSL, year: '' }));
          return;
        }
      }

      setIsDataLoaded(false);
      lastApiCallRef.current = { dslNo: '', year: '' };
      Object.keys(toastShownRef.current).forEach(key => {
        if (key.startsWith('validateDSL') || key.startsWith('validateDateRange')) {
          delete toastShownRef.current[key];
        }
      });
    }

    // Clear validation toast refs when DSL No changes
    if (name === "dslNo") {
      Object.keys(toastShownRef.current).forEach(key => {
        if (key.startsWith('validateDSL')) {
          delete toastShownRef.current[key];
        }
      });
    }
  }, [autoResizeDescription, validateEmail, getConfig, getUserInfo]);


  const handleStartDateChange = useCallback((date) => {
    setStartDate(date);
    Object.keys(toastShownRef.current).forEach(key => {
      if (key.startsWith('validateDateRange')) {
        delete toastShownRef.current[key];
      }
    });
    if (endDate && date && endDate < date) {
      setEndDate(null);
      const toastKey = 'date-start-end-warning';
      if (!toastShownRef.current[toastKey]) {
        toast.warning('End date cannot be before start date', messages.COLOR_RED);
        toastShownRef.current[toastKey] = true;
        setTimeout(() => delete toastShownRef.current[toastKey], 3000);
      }
    }
  }, [endDate]);

  const handleEndDateChange = useCallback((date) => {
    Object.keys(toastShownRef.current).forEach(key => {
      if (key.startsWith('validateDateRange')) {
        delete toastShownRef.current[key];
      }
    });
    if (startDate && date && date < startDate) {
      const toastKey = 'date-end-before-start';
      if (!toastShownRef.current[toastKey]) {
        toast.error('End date cannot be before start date', messages.COLOR_RED);
        toastShownRef.current[toastKey] = true;
        setTimeout(() => delete toastShownRef.current[toastKey], 3000);
      }
      return;
    }
    setEndDate(date);
  }, [startDate]);

  const validateDSLMandatory = useCallback(() => {
    const toastKey = 'validateDSL';

    if (!formData.dslNo || formData.dslNo.trim() === '') {
      if (!toastShownRef.current[`${toastKey}-dsl-mandatory`]) {
        toast.error('DSL No. is mandatory', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-dsl-mandatory`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-dsl-mandatory`], 3000);
      }
      return false;
    }

    if (formData.dslNo.length !== 6) {
      if (!toastShownRef.current[`${toastKey}-dsl-length`]) {
        toast.error('DSL No. should be 6 digits', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-dsl-length`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-dsl-length`], 3000);
      }
      return false;
    }

    if (!/^\d{6}$/.test(formData.dslNo)) {
      if (!toastShownRef.current[`${toastKey}-dsl-numeric`]) {
        toast.error('DSL No. should contain only numbers', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-dsl-numeric`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-dsl-numeric`], 3000);
      }
      return false;
    }

    if (!formData.year || formData.year.trim() === '') {
      if (!toastShownRef.current[`${toastKey}-year-mandatory`]) {
        toast.error('Year is mandatory', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-year-mandatory`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-year-mandatory`], 3000);
      }
      return false;
    }

    return true;
  }, [formData.dslNo, formData.year]);

  const validateDateRange = useCallback(() => {
    const toastKey = 'validateDateRange';

    if (!startDate && !endDate) {
      return true;
    }

    if ((startDate && !endDate) || (!startDate && endDate)) {
      if (!toastShownRef.current[`${toastKey}-both-dates`]) {
        toast.error('Please select both start and end dates or leave both empty', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-both-dates`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-both-dates`], 3000);
      }
      return false;
    }

    if (startDate && endDate && endDate < startDate) {
      if (!toastShownRef.current[`${toastKey}-end-before-start`]) {
        toast.error('End date cannot be before start date', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-end-before-start`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-end-before-start`], 3000);
      }
      return false;
    }

    return true;
  }, [startDate, endDate]);

  const handleReset = useCallback(() => {
    console.log('🔄 Reset button clicked - clearing all data');

    setFormData({
      year: '',
      scheduleDespatchNo: '',
      pslNo: '',
      schemeCode: '',
      industryCodeFrame: '',
      industryCodeReturn: '',
      descriptionOfIndustry: '',
      state: '',
      stateCode: '',
      district: '',
      sector: '',
      roSroCode: '',
      numberOfUnits: '',
      statusOfUnit: '',
      nameUnit: '',
      addressUnit: '',
      villTown: '',
      districtName: '',
      stateName: '',
      pinCode: '',
      emailId: '',
      mobileNumber: '',
      typeOfOrg: '',
      hasCIN: '',
      cin: '',
      isoCert: '',
      yearOfInitialProd: '',
      accountingYearFrom: '',
      accountingYearTo: '',
      monthsOfOperation: '',
      shareCapital: '',
      rdUnit: '',
      rdMaleEmployees: '',
      rdFemaleEmployees: '',
      rdTransgenderEmployees: '',
      contactName: '',
      contactTele: '',
      contactFax: '',
      contactEmail: '',
      contactPersonName: '',
      contactPersonDesignation: '',
      contactPersonEmail: '',
      contactPersonMobile: '',
      formalTraining: '',
      trainingMaleEmployees: '',
      trainingFemaleEmployees: '',
      trainingTransgenderEmployees: '',
      gstin: '',
      dslNo: '', // Added DSL No. field to state
      verificationCompilationDate: '',
      entryMode: 'balanceSheet',
      documentPath: '',
      documentPathFull: '', 
      uploadScheduleFileName: '',
      uploadScheduleFilePath: '',
      remarksBlock: '', 
      remarksItems: '', 
      remarks: '', 
      remarksCreatedOn: '', 
      remarksBy: '',
      remarksRole: '', 
    });

    setStartDate(null);
    setEndDate(null);
    setVerificationDate(null);

    setUploadedFile(null);
    setUploadScheduleFile(null);
    setFormData(prev => ({ ...prev, uploadScheduleFileName: '' }));

    setIsDataLoaded(false);
    setIsApiLoading(false);
    setIsFirstLoad(false);

    lastApiCallRef.current = { dslNo: '', year: '' };

    setRemarksList([]);

    try {
      localStorage.removeItem('balanceSheetFormData');
      clearSavedPages();
      window.dispatchEvent(new CustomEvent('refreshBalanceSheetHeader'));
    } catch (error) {
      console.error('Error clearing form data from localStorage:', error);
    }

    console.log('✅ Reset completed - ready for new API calls');
  }, []);

  const fetchNicIndustryDescription = useCallback(async (nicCode) => {
    if (!nicCode || nicCode.length !== 5) {
      return;
    }

    try {
      showLoading(true);
      const response = await axios.get(
        `${API_URL}api/asi/nicIndustryMaster?niccode=${nicCode}`,
        getConfig()
      );

      if (response.data && response.data.status && response.data.data && response.data.data.length > 0) {
        const nicDescription = response.data.data[0].nicDescription || '';
        // Update description of industry field
        setFormData(prev => ({
          ...prev,
          descriptionOfIndustry: nicDescription
        }));
      } else {
        // If status is false, show error message from response
        if (response.data && response.data.status === false && response.data.message) {
          toast.error(response.data.message, messages.COLOR_RED);
        }
        // If no data found, clear description
        setFormData(prev => ({
          ...prev,
          descriptionOfIndustry: ''
        }));
      }
    } catch (error) {
      console.error('Error fetching NIC Industry Description:', error);
      setFormData(prev => ({
        ...prev,
        descriptionOfIndustry: ''
      }));
      toast.error('NIC Industry code not found', messages.COLOR_RED);
    } finally {
      showLoading(false);
    }
  }, [getConfig]);

  const fetchIdentificationData = useCallback(async (dslNo, surveyYear, skipLoading = false, forceRefresh = false) => {
    if (!dslNo || !surveyYear) return false;

    const userInfo = getUserInfo();
    if (userInfo && userInfo.ROLE_CODE === 'FACTO' && userInfo.USER_ID) {
      const expectedDSL = String(userInfo.USER_ID).trim();
      const enteredDSL = String(dslNo).trim();

      if (enteredDSL !== expectedDSL) {
        toast.error('Invalid DSL No.', messages.COLOR_RED);
        setFormData(prev => ({ ...prev, dslNo: expectedDSL }));
        return false;
      }
    }

    if (!forceRefresh) {
      if (isApiLoading) {
        console.log('API call already in progress, skipping...');
        return false;
      }
      if (lastApiCallRef.current.dslNo === dslNo && lastApiCallRef.current.year === surveyYear) {
        console.log('API already called for this DSL and Year combination, skipping...');
        return true;
      }
      if (isDataLoaded && formData.dslNo === dslNo && formData.year === surveyYear) {
        console.log('Data already loaded for this DSL and Year');
        return true;
      }
    } else {
      if (isApiLoading) return false;
    }

    setIsApiLoading(true);
    if (!skipLoading) showLoading(true);

    try {
      const postData = {
        dsl_no: dslNo,
        survey_year: surveyYear.split('-')[0]
      };

      console.log('Making API call for DSL:', dslNo, 'Year:', surveyYear);

      lastApiCallRef.current = { dslNo, year: surveyYear };

      const response = await axios.post(`${API_URL}api/identification-particulars/get-data`, postData, getConfig());

      console.log('API Response:', response.data);

      const { data, status, message, remarks: remarksArray } = response.data;

      console.log('Extracted - Status:', status, 'Message:', message, 'Data:', data, 'Remarks:', remarksArray);

      // Handle case when status is false or no data found
      if (status === false || !data || (Array.isArray(data) && data.length === 0)) {
        const errorMessage = message || 'No data found for the specified DSL and survey year';
        console.log('⚠️ No data case - Showing message:', errorMessage);
        toast.warning(errorMessage, messages.COLOR_RED);
        setIsApiLoading(false);
        if (!skipLoading) showLoading(false);
        return false;
      }

      if (data && status && data.length > 0) {
        const apiData = data[0];

        console.log('API Data received:', apiData);

        let sectorValue = '';
        if (apiData.sectorCode) {
          sectorValue = apiData.sectorCode.toString();
        } else if (apiData.sector === 'Rural' || apiData.sector === '1' || apiData.sector === 1) {
          sectorValue = '1';
        } else if (apiData.sector === 'Urban' || apiData.sector === '2' || apiData.sector === 2) {
          sectorValue = '2';
        }

        let isoCertValue = '';
        if (apiData.isoCertification14000 === 'Yes' || apiData.isoCertification14000 === '1' || apiData.isoCert === '1') {
          isoCertValue = '1';
        } else if (apiData.isoCertification14000 === 'No' || apiData.isoCertification14000 === '2' || apiData.isoCert === '2') {
          isoCertValue = '2';
        }

        let formalTrainingValue = '';
        if (apiData.formalTraining === 'Yes' || apiData.formalTraining === '1') {
          formalTrainingValue = '1';
        } else if (apiData.formalTraining === 'No' || apiData.formalTraining === '2') {
          formalTrainingValue = '2';
        }

        let formattedYear = surveyYear;
        if (apiData.surveyYear) {
          const year = parseInt(apiData.surveyYear);
          if (!isNaN(year)) {
            formattedYear = `${year}-${(year + 1).toString().slice(-2)}`;
          }
        }

        const updatedFormData = {
          ...formData,
          dslNo: apiData.dslNo?.toString() || dslNo,
          year: formattedYear || surveyYear,
          scheduleDespatchNo: apiData.scheduleDespatchNo?.toString() || apiData.dslNo?.toString() || '',
          pslNo: apiData.pslNo?.toString() || '',
          schemeCode: apiData.schemeCode?.toString() || '',
          industryCodeFrame: apiData.nicCodePerFrame?.toString() || apiData.industryCodeFrame?.toString() || '',
          industryCodeReturn: apiData.industryCodeReturn?.toString() || '',
          descriptionOfIndustry: apiData.descriptionOfIndustry?.toString() || '',
          sector: sectorValue || '',
          roSroCode: apiData.roSroCode?.toString() || '',
          numberOfUnits: '1', // Always 1 when data comes from API
          statusOfUnit: apiData.statusOfUnitCode?.toString() || apiData.statusOfUnit?.toString() || '',
          typeOfOrg: apiData.typeOrganizationCode?.toString() || apiData.typeOfOrg?.toString() || '',
          yearOfInitialProd: apiData.yearInitialProduction?.toString() || apiData.yearOfInitialProd?.toString() || '',
          monthsOfOperation: apiData.numberOfMonthsOperation?.toString() || apiData.monthsOfOperation?.toString() || '',
          isoCert: isoCertValue || '',
          nameUnit: apiData.Name_Unit?.toString() || apiData.nameUnit?.toString() || apiData.addressUnit?.toString() || '',
          addressUnit: apiData.Address_Unit?.toString() || apiData.addressUnit?.toString() || '',
          villTown: apiData.Place_Unit?.toString() || apiData.villTown?.toString() || apiData.placeUnit?.toString() || '',
          district: apiData.districtCode?.toString() || apiData.district?.toString() || '',
          districtName: apiData.District_Name?.toString() || apiData.districtName?.toString() || '',
          state: apiData.state?.toString() || apiData.stateCode?.toString() || '',
          stateCode: apiData.stateCode?.toString() || '',
          stateName: apiData.State_Name?.toString() || apiData.stateName?.toString() || '',
          pinCode: apiData.pinCode?.toString() || apiData.pin?.toString() || '',
          emailId: apiData.emailId?.toString() || apiData.email?.toString() || '',
          mobileNumber: apiData.mobileNumber?.toString() || apiData.mobile?.toString() || '',
          hasCIN: apiData.hasCIN?.toString() || '',
          cin: apiData.corporateIdentificationNumber?.toString() || apiData.cin?.toString() || '',
          contactName: apiData.contactName?.toString() || '',
          contactTele: apiData.contactTele?.toString() || apiData.tele?.toString() || '',
          contactFax: apiData.contactFax?.toString() || apiData.fax?.toString() || '',
          contactEmail: apiData.contactEmail?.toString() || '',
          contactPersonName: apiData.contactPersonName?.toString() || '',
          contactPersonDesignation: apiData.contactPersonDesignation?.toString() || '',
          contactPersonEmail: apiData.contactPersonEmail?.toString() || '',
          contactPersonMobile: apiData.contactPersonMobile?.toString() || '',
          formalTraining: formalTrainingValue || '',
          shareCapital: apiData.shareCapital?.toString() || '',
          rdUnit: apiData.rdUnit?.toString() || '',
          rdMaleEmployees: apiData.rdMaleEmployees?.toString() || '',
          rdFemaleEmployees: apiData.rdFemaleEmployees?.toString() || '',
          rdTransgenderEmployees: apiData.rdTransgenderEmployees?.toString() || '',
          trainingMaleEmployees: apiData.trainingMaleEmployees?.toString() || '',
          trainingFemaleEmployees: apiData.trainingFemaleEmployees?.toString() || '',
          trainingTransgenderEmployees: apiData.trainingTransgenderEmployees?.toString() || '',
          gstin: apiData.gstin?.toString() || '',
          verificationCompilationDate: (apiData.Compilation_Date?.toString() || apiData.verificationCompilationDate?.toString() || apiData.compilationDate?.toString()) || formatDateDDMMYYYY(),
          documentPath: (() => {
            // Extract filename from path if uploadedFile contains path
            const filePath = apiData.uploadedFile?.toString() || apiData.documentPath?.toString() || '';
            if (filePath) {
              const fileName = filePath.split('/').pop() || filePath;
              return fileName;
            }
            return '';
          })(),
          documentPathFull: apiData.uploadedFile?.toString() || apiData.documentPath?.toString() || '', // Store full path for download
          accountingYearFrom: apiData.accountingYearStart?.toString() || apiData.accountingYearFrom?.toString() || '',
          accountingYearTo: apiData.accountingYearEnd?.toString() || apiData.accountingYearTo?.toString() || '',
          remarksBlock: '',
          remarksItems: '',
          remarks: ''
        };

        console.log('Updated form data:', updatedFormData);

        // Batch state updates for better performance
        setFormData(updatedFormData);
        if (updatedFormData.dslNo && updatedFormData.year) {
          try {
            localStorage.setItem('balanceSheetDslYear', JSON.stringify({ dslNo: updatedFormData.dslNo, year: updatedFormData.year }));
          } catch (_) {}
        }
        if (updatedFormData.statusOfUnit != null && updatedFormData.statusOfUnit !== '') {
          try {
            localStorage.setItem('statusUnitCode', String(updatedFormData.statusOfUnit));
          } catch (_) {}
        }
        const statusCode = String(updatedFormData.statusOfUnit ?? '').trim();
        if (['4', '5', '7', '8'].includes(statusCode)) {
          try {
            localStorage.setItem('balanceSheetAccessPageIds', JSON.stringify([1, 11]));
            localStorage.setItem('balanceSheetApiCalled', 'true');
            window.dispatchEvent(new CustomEvent('balanceSheetValidationUpdated', { detail: [1, 11] }));
          } catch (_) {}
        }
        requestAnimationFrame(() => autoResizeDescription());
        setIsDataLoaded(true);

        if (remarksArray && Array.isArray(remarksArray) && remarksArray.length > 0) {
          const mappedRemarksList = remarksArray.map((remark, index) => ({
            slNo: index + 1,
            blocks: remark.block?.toString() || '',
            columns: remark.columnsName?.toString() || '-',
            items: remark.items?.toString() || remark.itemNo?.toString() || remark.itemCode?.toString() || remark.itemDescription?.toString() || '',
            remarks: remark.remarks?.toString() || '',
            createdTime: remark.createdDate || remark.createdTime || '',
            updatedBy: remark.updatedBy?.toString() || remark.createdBy?.toString() || '',
            role: remark.updatedBy?.toString() || remark.createdBy?.toString() || ''
          }));
          setRemarksList(mappedRemarksList);
          console.log('Mapped Remarks List:', mappedRemarksList);
        } else {
          setRemarksList([]);
        }

        if (apiData.accountingYear) {
          const yearParts = apiData.accountingYear.split('-');
          if (yearParts.length === 2) {
            const startYear = parseInt(yearParts[0]);
            if (!isNaN(startYear)) {
              setStartDate(new Date(startYear, 3, 1));
              setEndDate(new Date(startYear + 1, 2, 31));
            }
          }
        }

        try {
          const dataToSave = {
            ...updatedFormData,
            accountingYearFrom: startDate ? startDate.toISOString() : null,
            accountingYearTo: endDate ? endDate.toISOString() : null
          };
          localStorage.setItem('balanceSheetFormData', JSON.stringify(dataToSave));
          localStorage.setItem('balanceSheetDataLoaded', 'true');
          const currentLoginTime = localStorage.getItem('loginTime');
          if (currentLoginTime) {
            localStorage.setItem('balanceSheetLoginTime', currentLoginTime);
          }
        } catch (error) {
          console.error('Error saving to localStorage:', error);
        }

        // Refresh balance sheet validation to update header colors after fetching data
        if (dslNo && surveyYear) {
          await refreshBalanceSheetValidation(dslNo, surveyYear);
        }

        return true;
      }

    } catch (error) {
      console.error('API Error:', error);

      // Handle specific error responses
      if (error.response && error.response.data) {
        const { status, message } = error.response.data;

        // If API explicitly returns status: false with a message
        if (status === false && message) {
          toast.warning(message, messages.COLOR_RED);
        } else if (error.response.status === 404) {
          toast.warning('No data found for the specified DSL and survey year', messages.COLOR_RED);
        } else if (error.response.status === 401) {
          toast.error('Session expired. Please login again.', messages.COLOR_RED);
        } else if (error.response.status === 500) {
          toast.error('Server error. Please try again later.', messages.COLOR_RED);
        } else {
          const errorMsg = message || error.response.data.message || 'An error occurred while processing your request.';
          toast.error(errorMsg, messages.COLOR_RED);
        }
      } else {
        toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      }
      return false;
    } finally {
      setIsApiLoading(false);
      if (!skipLoading) showLoading(false);
    }
  }, [autoResizeDescription, isApiLoading, isDataLoaded, formData.dslNo, formData.year, getConfig, startDate, endDate, formatDateDDMMYYYY, getUserInfo]);

  // BlockA style: refresh pe get-data call – sirf pathname change pe (fetchIdentificationData deps me mat daalo, re-render loop)
  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath !== '/balanceSheet') return;

    let dsl = '';
    let year = '';
    try {
      const raw = localStorage.getItem('balanceSheetFormData');
      if (raw) {
        const parsed = JSON.parse(raw);
        const rawDsl = parsed.dslNo ?? parsed.dsl_no ?? '';
        const rawYear = parsed.year ?? parsed.surveyYear ?? parsed.survey_year ?? '';
        dsl = String(rawDsl).trim();
        year = rawYear ? String(rawYear).trim() : '';
        if (year && /^\d{4}$/.test(year)) {
          year = `${year}-${(parseInt(year, 10) + 1).toString().slice(-2)}`;
        }
      }
      if (!dsl || !year) {
        const dslYearRaw = localStorage.getItem('balanceSheetDslYear');
        if (dslYearRaw) {
          const dslYear = JSON.parse(dslYearRaw);
          dsl = String(dslYear.dslNo ?? '').trim();
          year = String(dslYear.year ?? '').trim();
          if (year && /^\d{4}$/.test(year)) {
            year = `${year}-${(parseInt(year, 10) + 1).toString().slice(-2)}`;
          }
        }
      }
      if (!dsl || !year) return;

      lastApiCallRef.current = { dslNo: '', year: '' };
      setIsDataLoaded(false);
      fetchIdentificationData(dsl, year, false, true);
    } catch (e) {
      console.error('get-data on pathname (refresh):', e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sirf pathname pe run karo, fetchIdentificationData deps me na lo (re-render loop)
  }, [location.pathname]);

  const storedLanguage = localStorage.getItem('language');

  // Listen for logout (token removal) and clear DSL No and Year
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'jwt' || e.key === 'token' || e.key === 'accessToken') {
        // Token was removed (logout)
        if (!e.newValue || e.newValue === 'null' || e.newValue.trim() === '') {
          console.log('🔄 Logout detected - clearing DSL No and Year');
          setFormData(prev => ({ ...prev, dslNo: '', year: '' }));
          localStorage.removeItem('balanceSheetFormData');
          clearSavedPages();
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Also check on mount if session exists
    if (!hasAuthSession()) {
      setFormData(prev => ({ ...prev, dslNo: '', year: '' }));
      localStorage.removeItem('balanceSheetFormData');
      clearSavedPages();
    }

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Fetch Industry Code Return data on component mount
  useEffect(() => {
    const fetchIndustryCodeReturn = async () => {
      try {
        showLoading(true);
        const response = await axios.get(`${API_URL}api/input-items-indigenous/IndustrycodeasperReturnData`, getConfig());

        if (response.data && response.data.status && response.data.data) {
          setIndustryCodeReturnList(response.data.data);
        } else {
          console.error('Failed to fetch industry codes:', response.data?.message);
        }
      } catch (error) {
        console.error('Error fetching industry codes:', error);
        toast.error('Failed to load industry codes', messages.COLOR_RED);
      } finally {
        showLoading(false);
      }
    };

    fetchIndustryCodeReturn();
  }, []);

  // Fetch Unit Codes for StatusUnitDropdown
  useEffect(() => {
    const fetchUnitCodes = async () => {
      try {
        const response = await axios.get(`${API_URL}api/asi/unitCodes`, getConfig());
        if (response.data && response.data.status) {
          setUnitCodes(response.data.data || []);
        }
      } catch (error) {
        console.error('Error fetching unit codes:', error);
        setUnitCodes([]);
      }
    };

    fetchUnitCodes();
  }, []);

  useEffect(() => {
    autoResizeDescription();
  }, [autoResizeDescription]);

  useEffect(() => {
    autoResizeDescription();
  }, [autoResizeDescription, formData.descriptionOfIndustry]);


  // Memoized API call logic - only call when user manually enters DSL and Year
  const shouldMakeApiCall = useMemo(() => {
    const result = !isFirstLoad && // Not first load
      formData.dslNo &&
      formData.dslNo.length === 6 &&
      formData.year &&
      !isDataLoaded &&
      !isApiLoading &&
      (lastApiCallRef.current.dslNo !== formData.dslNo || lastApiCallRef.current.year !== formData.year);

    console.log('🔍 shouldMakeApiCall Check:', {
      isFirstLoad,
      dslNo: formData.dslNo,
      dslLength: formData.dslNo?.length,
      year: formData.year,
      isDataLoaded,
      isApiLoading,
      lastApiCall: lastApiCallRef.current,
      result
    });

    return result;
  }, [isFirstLoad, formData.dslNo, formData.year, isDataLoaded, isApiLoading]);

  // Load saved data on component mount (with route-based logic)
  useEffect(() => {
    let isMounted = true;

    const loadDataWithRouteCheck = async () => {
      try {
        // Check if user is logged out
        if (!hasAuthSession()) {
          // User is logged out - clear DSL No and Year
          console.log('🔄 User logged out - clearing DSL No and Year');
          localStorage.removeItem('balanceSheetFormData');
          setFormData(prev => ({ ...prev, dslNo: '', year: '' }));
          setIsFirstLoad(false);
          setIsDataLoaded(true);
          return;
        }

        // Get user info for FACTO role auto-fill
        const userInfo = getUserInfo();
        const isFACTO = userInfo && userInfo.ROLE_CODE === 'FACTO';
        const userDSL = isFACTO && userInfo.USER_ID ? String(userInfo.USER_ID).trim() : '';

        // Check if this is a new login session (loginTime changed)
        const currentLoginTime = localStorage.getItem('loginTime');
        const savedLoginTime = localStorage.getItem('balanceSheetLoginTime');

        // If loginTime doesn't match, it means user logged out and logged in again
        if (currentLoginTime && savedLoginTime && currentLoginTime !== savedLoginTime) {
          console.log('🔄 New login session detected - clearing saved data');
          localStorage.removeItem('balanceSheetFormData');
          clearSavedPages();
          // For FACTO role, set USER_ID as DSL No
          if (isFACTO && userDSL) {
            setFormData(prev => ({
              ...prev,
              dslNo: userDSL,
              year: '',
              verificationCompilationDate: formatDateDDMMYYYY()
            }));
          } else {
            setFormData(prev => ({
              ...prev,
              dslNo: '',
              year: '',
              verificationCompilationDate: formatDateDDMMYYYY()
            }));
          }
          setIsFirstLoad(false);
          setIsDataLoaded(true);
          // Save current loginTime for next check
          localStorage.setItem('balanceSheetLoginTime', currentLoginTime);
          return;
        }

        // If no saved loginTime, save current one
        if (currentLoginTime && !savedLoginTime) {
          localStorage.setItem('balanceSheetLoginTime', currentLoginTime);
        }

        // Check if coming from asiScheduleMainMenu
        const fromMainMenuFlag = localStorage.getItem('fromAsiScheduleMainMenu');
        const isFromMainMenu = fromMainMenuFlag === 'true';

        console.log('Route Check - Flag:', fromMainMenuFlag, 'isFromMainMenu:', isFromMainMenu);

        // Clear the flag
        if (fromMainMenuFlag) {
          localStorage.removeItem('fromAsiScheduleMainMenu');
        }

        // For FACTO role, always use USER_ID and clear saved data if DSL doesn't match
        if (isFACTO && userDSL) {
          const savedData = localStorage.getItem('balanceSheetFormData');
          if (savedData) {
            try {
              const parsedData = JSON.parse(savedData);
              // If saved DSL doesn't match USER_ID, clear saved data
              if (parsedData.dslNo && String(parsedData.dslNo).trim() !== userDSL) {
                console.log('🔄 FACTO user - Saved DSL does not match USER_ID, clearing saved data');
                console.log('Saved DSL:', parsedData.dslNo, 'Expected USER_ID:', userDSL);
                localStorage.removeItem('balanceSheetFormData');
                clearSavedPages();
                // Set fresh data with USER_ID
                setFormData({
                  year: '', scheduleDespatchNo: '', pslNo: '', schemeCode: '',
                  industryCodeFrame: '', industryCodeReturn: '', descriptionOfIndustry: '',
                  state: '', district: '', sector: '', roSroCode: '', numberOfUnits: '',
                  statusOfUnit: '', nameUnit: '', addressUnit: '', villTown: '',
                  districtName: '', stateName: '', pinCode: '', typeOfOrg: '', cin: '',
                  isoCert: '', yearOfInitialProd: '', accountingYearFrom: '',
                  accountingYearTo: '', monthsOfOperation: '', shareCapital: '',
                  rdUnit: '', contactName: '', contactTele: '', contactFax: '',
                  contactEmail: '', formalTraining: '', dslNo: userDSL,
                  verificationCompilationDate: formatDateDDMMYYYY(),
                  entryMode: 'balanceSheet',
                  documentPath: '', documentPathFull: '', uploadScheduleFileName: '',
                  uploadScheduleFilePath: '', remarksBlock: '', remarksItems: '',
                  remarks: '', remarksCreatedOn: '', remarksBy: '', remarksRole: ''
                });
                setStartDate(null);
                setEndDate(null);
                setErrors({ contactEmail: '', cin: '' });
                setIsFirstLoad(false);
                setIsDataLoaded(true);
                return;
              }
            } catch (error) {
              console.error('Error parsing saved data:', error);
              localStorage.removeItem('balanceSheetFormData');
            }
          }
        }

        // Always check for saved data first, regardless of route
        const savedData = localStorage.getItem('balanceSheetFormData');

        if (savedData && isMounted) {
          const parsedData = JSON.parse(savedData);

          if (isFACTO && userDSL) {
            parsedData.dslNo = userDSL;
          }

          if (isFromMainMenu) {
            console.log('✅ Loading from Main Menu - Data will be loaded, API will be called');
            console.log('📦 Parsed Data:', parsedData);

            const dataWithDate = {
              ...parsedData,
              dslNo: isFACTO && userDSL ? userDSL : parsedData.dslNo,
              year: isFACTO && userDSL ? '' : parsedData.year,
              verificationCompilationDate: parsedData.verificationCompilationDate || formatDateDDMMYYYY()
            };
            setFormData(dataWithDate);

            if (currentLoginTime) {
              localStorage.setItem('balanceSheetLoginTime', currentLoginTime);
            }

            if (parsedData.accountingYearFrom && parsedData.accountingYearTo) {
              setStartDate(new Date(parsedData.accountingYearFrom));
              setEndDate(new Date(parsedData.accountingYearTo));
            }

            // Set flags
            setIsFirstLoad(false);
            setIsDataLoaded(false);
            lastApiCallRef.current = { dslNo: '', year: '' };

            // DIRECTLY CALL API HERE - use dataWithDate.dslNo (which has USER_ID for FACTO)
            if (dataWithDate.dslNo && dataWithDate.year) {
              console.log('🚀 Calling API directly for DSL:', dataWithDate.dslNo, 'Year:', dataWithDate.year);
              setTimeout(() => {
                fetchIdentificationData(dataWithDate.dslNo, dataWithDate.year);
              }, 100);
            }
          } else {
            // Other page / refresh / header link – user wapas is page pe aaya: hamesha get-data call karo
            const rawDsl = parsedData.dslNo ?? parsedData.dsl_no ?? '';
            const rawYear = parsedData.year ?? parsedData.surveyYear ?? parsedData.survey_year ?? '';
            const dslNoFromStorage = String(rawDsl).trim();
            let yearFromStorage = rawYear ? String(rawYear).trim() : '';
            if (yearFromStorage && /^\d{4}$/.test(yearFromStorage)) {
              yearFromStorage = `${yearFromStorage}-${(parseInt(yearFromStorage, 10) + 1).toString().slice(-2)}`;
            }
            const dataWithDate = {
              ...parsedData,
              dslNo: isFACTO && userDSL ? userDSL : dslNoFromStorage,
              year: isFACTO && userDSL ? '' : yearFromStorage,
              verificationCompilationDate: parsedData.verificationCompilationDate || formatDateDDMMYYYY()
            };
            setFormData(dataWithDate);
            if (currentLoginTime) {
              localStorage.setItem('balanceSheetLoginTime', currentLoginTime);
            }
            if (parsedData.accountingYearFrom && parsedData.accountingYearTo) {
              setStartDate(new Date(parsedData.accountingYearFrom));
              setEndDate(new Date(parsedData.accountingYearTo));
            }
            setIsFirstLoad(false);
            // Jab bhi user is page pe aaye (dusre page se, refresh, ya header link) – get-data call karo
            if (dslNoFromStorage.length === 6 && yearFromStorage) {
              console.log('🔄 Back on balance sheet page – Calling get-data for DSL:', dslNoFromStorage, 'Year:', yearFromStorage);
              setIsDataLoaded(false);
              lastApiCallRef.current = { dslNo: '', year: '' };
              setTimeout(() => {
                fetchIdentificationData(dslNoFromStorage, yearFromStorage);
              }, 100);
            } else {
              setIsDataLoaded(true);
              if (dslNoFromStorage || yearFromStorage) {
                lastApiCallRef.current = { dslNo: dslNoFromStorage, year: yearFromStorage };
              }
            }
          }
        } else {
          console.log('❌ No saved data found - Setting default values');

          // Auto-fill DSL No for FACTO role
          const initialDSL = isFACTO && userDSL ? userDSL : '';

          setFormData({
            year: '', scheduleDespatchNo: '', pslNo: '', schemeCode: '',
            industryCodeFrame: '', industryCodeReturn: '', descriptionOfIndustry: '',
            state: '', district: '', sector: '', roSroCode: '', numberOfUnits: '',
            statusOfUnit: '', nameUnit: '', addressUnit: '', villTown: '',
            districtName: '', stateName: '', pinCode: '', typeOfOrg: '', cin: '',
            isoCert: '', yearOfInitialProd: '', accountingYearFrom: '',
            accountingYearTo: '', monthsOfOperation: '', shareCapital: '',
            rdUnit: '', contactName: '', contactTele: '', contactFax: '',
            contactEmail: '', formalTraining: '', dslNo: initialDSL,
            verificationCompilationDate: formatDateDDMMYYYY(),
            entryMode: 'balanceSheet',
            documentPath: '', documentPathFull: '', uploadScheduleFileName: '',
            uploadScheduleFilePath: '', remarksBlock: '', remarksItems: '',
            remarks: '', remarksCreatedOn: '', remarksBy: '', remarksRole: ''
          });

          setStartDate(null);
          setEndDate(null);
          setErrors({ contactEmail: '', cin: '' });
          setIsFirstLoad(false);
          setIsDataLoaded(true);

          // Save current loginTime for next check
          if (currentLoginTime) {
            localStorage.setItem('balanceSheetLoginTime', currentLoginTime);
          }
        }
      } catch (error) {
        console.error('Error in route check:', error);
      }
    };

    loadDataWithRouteCheck();

    return () => {
      isMounted = false;
    };
  }, [getUserInfo, formatDateDDMMYYYY]);

  // Single useEffect for API calls with useMemo optimization
  useEffect(() => {
    console.log('shouldMakeApiCall===>', shouldMakeApiCall);
    console.log('formData.dslNo===>', formData.dslNo);
    console.log('formData.year===>', formData.year);
    if (shouldMakeApiCall) {
      console.log('Making API call for DSL:', formData.dslNo, 'Year:', formData.year);
      fetchIdentificationData(formData.dslNo, formData.year);
    }
  }, [shouldMakeApiCall, fetchIdentificationData, formData.dslNo, formData.year]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      try {
        const dataToSave = {
          ...formData,
          accountingYearFrom: startDate ? startDate.toISOString() : null,
          accountingYearTo: endDate ? endDate.toISOString() : null
        };
        localStorage.setItem('balanceSheetFormData', JSON.stringify(dataToSave));
        if (formData.dslNo && formData.year) {
          localStorage.setItem('balanceSheetDslYear', JSON.stringify({ dslNo: formData.dslNo, year: formData.year }));
        }
        // Save loginTime to detect logout/login
        const currentLoginTime = localStorage.getItem('loginTime');
        if (currentLoginTime) {
          localStorage.setItem('balanceSheetLoginTime', currentLoginTime);
        }
      } catch (error) {
        console.error('Error saving form data to localStorage:', error);
      }
    }, 300); // 300ms debounce

    return () => clearTimeout(timeoutId);
  }, [formData, startDate, endDate]);

  const validateDSL = useCallback((dslNumber) => {
    let dslNo = dslNumber.toString();

    if (dslNo?.length === 0) {
      toast.error('DSL No. is mandatory', messages.COLOR_RED);
      return false;
    }
    else if (dslNo.length !== 6) {
      toast.error('DSL No. should be 6 digits', messages.COLOR_RED);
      return false;
    }
    else if (!/^\d{6}$/.test(dslNo)) {
      toast.error('DSL No. should contain only numbers', messages.COLOR_RED);
      return false;
    }
    else {
      return true;
    }
  }, []);

  // Remarks2 shows labels like "Block A" / "Item 1" but APIs expect compact codes.
  const normalizeRemarksBlockForApi = useCallback((val) => {
    const raw = (val ?? '').toString().trim();
    if (!raw) return '';
    if (raw === 'ALL') return 'ALL';
    // Accept either "A"/"B" or "Block A"/"Block B"
    const m = raw.match(/^Block\s+([A-Z])$/i);
    if (m && m[1]) return m[1].toUpperCase();
    if (raw.length === 1) return raw.toUpperCase();
    return raw;
  }, []);

  // Send full item name in API (e.g. "5. Industry code as per Return") instead of just number
  const normalizeRemarksItemForApi = useCallback((val) => {
    const raw = (val ?? '').toString().trim();
    return raw || '';
  }, []);

  const remarks2Data = useMemo(() => ({
    remarksBlock: formData.remarksBlock || '',
    remarksItems: formData.remarksItems || '',
    remarks: formData.remarks || ''
  }), [formData.remarksBlock, formData.remarksItems, formData.remarks]);

  // Item* options: when Block ALL → only ALL; when Block A → ALL + Block A items; when Block B → ALL + Block B items
  const remarks2ItemOptions = useMemo(() => {
    const block = (formData.remarksBlock || '').trim();
    const isAll = !block || block.toUpperCase() === 'ALL';
    const isBlockB = block.toLowerCase().includes('block b') || block === 'B';
    if (isAll) return ['ALL'];
    if (isBlockB) return ['ALL', ...BLOCK_B_ITEM_NAMES];
    return ['ALL', ...BLOCK_A_ITEM_NAMES];
  }, [formData.remarksBlock]);

  const setRemarks2Data = useCallback((updater) => {
    setFormData(prev => {
      const current = {
        remarksBlock: prev.remarksBlock || '',
        remarksItems: prev.remarksItems || '',
        remarks: prev.remarks || ''
      };
      const next = (typeof updater === 'function') ? updater(current) : (updater || {});
      const blockChanged = (next.remarksBlock ?? current.remarksBlock) !== current.remarksBlock;
      // When Block* changes, clear Item* so dropdown shows correct options (ALL only when Block ALL, else Block A/B items)
      const nextItems = blockChanged ? '' : (next.remarksItems ?? current.remarksItems);
      return {
        ...prev,
        remarksBlock: next.remarksBlock ?? current.remarksBlock,
        remarksItems: nextItems,
        remarks: next.remarks ?? current.remarks
      };
    });
  }, []);

  // Function to call the save-complete-asiframe API
  const handleSaveCompleteAsiFrame = useCallback(async () => {
    const toastKey = 'save-api';

    if (!formData.dslNo || formData.dslNo.trim() === '') {
      if (!toastShownRef.current[`${toastKey}-dsl-mandatory`]) {
        toast.error('DSL No. is mandatory', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-dsl-mandatory`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-dsl-mandatory`], 3000);
      }
      return false;
    }

    if (!formData.year || formData.year.trim() === '') {
      if (!toastShownRef.current[`${toastKey}-year-mandatory`]) {
        toast.error('Year is mandatory', messages.COLOR_RED);
        toastShownRef.current[`${toastKey}-year-mandatory`] = true;
        setTimeout(() => delete toastShownRef.current[`${toastKey}-year-mandatory`], 3000);
      }
      return false;
    }

    // Validate email
    const emailError = validateEmail(formData.contactEmail);
    if (emailError) {
      setErrors(prev => ({ ...prev, contactEmail: emailError }));
      const toastKey = 'save-email-error';
      if (!toastShownRef.current[toastKey]) {
        toast.error(emailError, messages.COLOR_RED);
        toastShownRef.current[toastKey] = true;
        setTimeout(() => delete toastShownRef.current[toastKey], 3000);
      }
      return false;
    }

    // Remarks2 validation: if Remarks text entered, Block* & Item* mandatory (block API call if invalid)
    const remarksValidation = validateRemarks2Section({
      remarksBlock: formData.remarksBlock || '',
      remarksItems: formData.remarksItems || '',
      remarks: formData.remarks || ''
    });
    if (!remarksValidation.valid) {
      const key = `${toastKey}-remarks2-validation`;
      if (!toastShownRef.current[key]) {
        toast.error(remarksValidation.message || 'Please fill Remarks section properly.', messages.COLOR_RED);
        toastShownRef.current[key] = true;
        setTimeout(() => delete toastShownRef.current[key], 3000);
      }
      return false; // stop: do not call save API
    }

    // Validate contact person mobile (if provided, must be 10 digits) - Check mobile first
    if (formData.contactPersonMobile && formData.contactPersonMobile.trim() !== '') {
      if (!/^\d{10}$/.test(formData.contactPersonMobile.trim())) {
        toast.dismiss(); 
        toast.error('Mobile Number must be 10 digits for contact person', messages.COLOR_RED);
        return false;
      }
    }

    // Validate contact person email (if provided)
    if (formData.contactPersonEmail && formData.contactPersonEmail.trim() !== '') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.contactPersonEmail.trim())) {
        toast.dismiss(); 
        toast.error('Please enter a valid Email Id for contact person', messages.COLOR_RED);
        return false;
      }
    }

    // Validate all mandatory fields (marked with *)
    const mandatoryFields = [
      { field: 'sector', name: 'Sector', value: formData.sector },
      { field: 'statusOfUnit', name: 'Status of Unit', value: formData.statusOfUnit },
      { field: 'nameUnit', name: 'Name', value: formData.nameUnit },
      { field: 'addressUnit', name: 'Address', value: formData.addressUnit },
      { field: 'villTown', name: 'Village / Town', value: formData.villTown },
      { field: 'districtName', name: 'District Name', value: formData.districtName },
      { field: 'pinCode', name: 'Pincode', value: formData.pinCode },
      { field: 'mobileNumber', name: 'Mobile Number', value: formData.mobileNumber },
      { field: 'typeOfOrg', name: 'Type of organisation', value: formData.typeOfOrg },
      { field: 'isoCert', name: 'Whether the unit has ISO Certification, 14000 Series', value: formData.isoCert },
      { field: 'yearOfInitialProd', name: 'Year of initial production', value: formData.yearOfInitialProd },
      { field: 'accountingYearFrom', name: 'Accounting Year (From)', value: formData.accountingYearFrom },
      { field: 'accountingYearTo', name: 'Accounting Year (To)', value: formData.accountingYearTo },
      { field: 'monthsOfOperation', name: 'No of months operation', value: formData.monthsOfOperation }
    ];

    // Check each mandatory field
    for (const mandatoryField of mandatoryFields) {
      if (!mandatoryField.value || mandatoryField.value.toString().trim() === '') {
        const toastKey = `save-${mandatoryField.field}-mandatory`;
        if (!toastShownRef.current[toastKey]) {
          toast.error(`${mandatoryField.name} is mandatory`, messages.COLOR_RED);
          toastShownRef.current[toastKey] = true;
          setTimeout(() => delete toastShownRef.current[toastKey], 3000);
        }
        return false;
      }
    }

    // Conditional validation for Remarks Block and Remarks
    // If either Block or Remarks has data, then both become mandatory
    const remarksBlockValue = formData.remarksBlock ? formData.remarksBlock.toString().trim() : '';
    const remarksValue = formData.remarks ? formData.remarks.toString().trim() : '';

    if (remarksBlockValue !== '' || remarksValue !== '') {
      // At least one has data, so both are mandatory
      if (!remarksBlockValue) {
        const toastKey = 'save-remarksBlock-mandatory';
        if (!toastShownRef.current[toastKey]) {
          toast.error('Remarks Block is mandatory', messages.COLOR_RED);
          toastShownRef.current[toastKey] = true;
          setTimeout(() => delete toastShownRef.current[toastKey], 3000);
        }
        return false;
      }

      if (!remarksValue) {
        const toastKey = 'save-remarks-mandatory';
        if (!toastShownRef.current[toastKey]) {
          toast.error('Remarks is mandatory', messages.COLOR_RED);
          toastShownRef.current[toastKey] = true;
          setTimeout(() => delete toastShownRef.current[toastKey], 3000);
        }
        return false;
      }
    }
    // If both are empty, no validation needed - data can be saved

    // Validate Pincode - exactly 6 digits
    if (formData.pinCode) {
      const pinCodeValue = formData.pinCode.toString().trim();
      if (!/^\d{6}$/.test(pinCodeValue)) {
        const toastKey = 'save-pinCode-invalid';
        if (!toastShownRef.current[toastKey]) {
          toast.error('Pincode must be 6 digits', messages.COLOR_RED);
          toastShownRef.current[toastKey] = true;
          setTimeout(() => delete toastShownRef.current[toastKey], 3000);
        }
        return false;
      }
    }

    // Validate Email Id - proper email format
    if (formData.emailId && formData.emailId.trim() !== '') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.emailId.trim())) {
        const toastKey = 'save-emailId-invalid';
        if (!toastShownRef.current[toastKey]) {
          toast.error('Please enter a valid Email Id', messages.COLOR_RED);
          toastShownRef.current[toastKey] = true;
          setTimeout(() => delete toastShownRef.current[toastKey], 3000);
        }
        return false;
      }
    }

    // Validate Mobile Number - exactly 10 digits
    if (formData.mobileNumber) {
      const mobileValue = formData.mobileNumber.toString().trim();
      if (!/^\d{10}$/.test(mobileValue)) {
        const toastKey = 'save-mobileNumber-invalid';
        if (!toastShownRef.current[toastKey]) {
          toast.error('Mobile Number must be 10 digits', messages.COLOR_RED);
          toastShownRef.current[toastKey] = true;
          setTimeout(() => delete toastShownRef.current[toastKey], 3000);
        }
        return false;
      }
    }

    // CIN validation removed - accepting any format

    showLoading(true);

    try {
      // Construct the payload according to API specification
      const payloadData = {
        dsl_no: formData.dslNo || "",
        survey_year: formData.year ? parseInt(formData.year.split('-')[0]) : null,
        Compilation_Date: formData.verificationCompilationDate || "",
        pslNo: formData.pslNo || "",
        schemeCode: formData.schemeCode || "",
        industryCodeReturn: formData.industryCodeReturn || "",
        industryCodeFrame: formData.industryCodeFrame || "",
        descriptionOfIndustry: formData.descriptionOfIndustry || "",
        state: formData.stateName || formData.state || "",
        district: formData.district || "",
        sector: formData.sector || "",
        numberOfUnits: 1, // Always send 1 for No. of Units
        statusOfUnitCode: formData.statusOfUnit || "",
        statusFlag: formData.statusFlag || "",
        reason: formData.reason ? parseInt(formData.reason) : null,
        roSroCode: formData.roSroCode || "",
        typeOrganizationCode: formData.typeOfOrg || "",
        isoCertification14000: formData.isoCert || "",
        yearInitialProduction: formData.yearOfInitialProd ? parseInt(formData.yearOfInitialProd) : null,
        accountingYear: formData.year || "",
        accountingYearStart: formData.accountingYearFrom || "",
        accountingYearEnd: formData.accountingYearTo || "",
        numberOfMonthsOperation: formData.monthsOfOperation ? parseInt(formData.monthsOfOperation) : null,
        addressUnit: formData.addressUnit || formData.nameUnit || "",
        villTown: formData.villTown || "",
        districtName: formData.districtName || "",
        stateName: formData.stateName || "",
        pinCode: formData.pinCode || "",
        hasCIN: formData.hasCIN || "",
        email_id: formData.emailId || "",
        mobile_number: formData.mobileNumber || "",
        contactPersonName: formData.contactPersonName || "",
        contactPersonDesignation: formData.contactPersonDesignation || "",
        contactPersonEmail: formData.contactPersonEmail || "",
        contactPersonMobile: formData.contactPersonMobile || "",
        formalTraining: formData.formalTraining || "",
        shareCapital: formData.shareCapital ? parseFloat(formData.shareCapital) : null,
        rdUnit: formData.rdUnit || "",
        rdMaleEmployees: formData.rdMaleEmployees ? parseInt(formData.rdMaleEmployees) : 0,
        rdFemaleEmployees: formData.rdFemaleEmployees ? parseInt(formData.rdFemaleEmployees) : 0,
        rdTransgenderEmployees: formData.rdTransgenderEmployees ? parseInt(formData.rdTransgenderEmployees) : 0,
        trainingMaleEmployees: formData.trainingMaleEmployees ? parseInt(formData.trainingMaleEmployees) : null,
        trainingFemaleEmployees: formData.trainingFemaleEmployees ? parseInt(formData.trainingFemaleEmployees) : null,
        trainingTransgenderEmployees: formData.trainingTransgenderEmployees ? parseInt(formData.trainingTransgenderEmployees) : null,
        gstin: formData.gstin || "",
        items: normalizeRemarksItemForApi(formData.remarksItems) || "",
        block: normalizeRemarksBlockForApi(formData.remarksBlock) || "",
        columnsName: '-',
        items: normalizeRemarksItemForApi(formData.remarksItems) || "",
        remarks: formData.remarks || "",
        //formData.remarks || "",
        uploadedFile: formData.documentPath || ""
      };
      

      // If file is uploaded, use FormData, otherwise use JSON payload
      let payload;
      let config = getConfig();

      if (uploadedFile || uploadScheduleFile) {
        // Create FormData for file upload
        const formDataPayload = new FormData();

        Object.keys(payloadData).forEach(key => {
          if (key !== 'uploadedFile') { 
            const value = payloadData[key];
            if (value !== null && value !== undefined) {
              if (typeof value === 'object' && !(value instanceof File)) {
                // console.log("===",value)
                formDataPayload.append(key, JSON.stringify(value));
              } else {
                formDataPayload.append(key, value);
              }
            }
          }
        });


        // Append the uploaded file with key 'uploadedFile' if exists
        if (uploadedFile) {
          formDataPayload.append('uploadedFile', uploadedFile);
        }
        if (uploadScheduleFile) {
          formDataPayload.append('uploadSchedule', uploadScheduleFile);
        }

        payload = formDataPayload;

        delete config.headers['Content-Type'];
      } else {
        payload = payloadData;
      }

      const response = await axios.post(
        `${API_URL}api/identification-particulars/save-complete-asiframe`,
        payload,
        config
      );

      console.log('API Response:', response.data);

      if (response.data && response.data.status) {
        toast.success('Data saved successfully to ASI Frame!', messages.COLOR_RED);
        localStorage.setItem('balanceSheetDataSaved', 'true');
        markPageAsSaved(PAGE_NAMES.GENERAL_INFORMATION);
        const statusCode = String(formData.statusOfUnit ?? '').trim();
        if (['4', '5', '7', '8'].includes(statusCode)) {
          localStorage.setItem('balanceSheetAccessPageIds', JSON.stringify([1, 11]));
          localStorage.setItem('balanceSheetApiCalled', 'true');
          window.dispatchEvent(new CustomEvent('balanceSheetValidationUpdated', { detail: [1, 11] }));
        } else if (formData.dslNo && formData.year) {
          await refreshBalanceSheetValidation(formData.dslNo, formData.year);
        }
        return true;
      } else {
        toast.error(response.data.message || 'Failed to save data to ASI Frame', messages.COLOR_RED);
        return false;
      }

    } catch (error) {
      console.error('API Error:', error);
      const errorMessage = error.response?.data?.message || 'An error occurred while saving data to ASI Frame';
      toast.error(errorMessage, messages.COLOR_RED);
      return false;
    } finally {
      showLoading(false);
    }
  }, [autoResizeDescription, formData, validateEmail, getConfig]);


  return (
    <>
      <div className="card mx-3 mb-3">
        <div className="card-body">
          <div className="row align-items-center">
            <div className="col-md-12">
              <h4 className="page_heading mb-0 pb-0 border-bottom-0">
                ASI Schedule 2024-25 <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>CONFIDENTIAL <i className="fa fa-lock me-2" style={{ fontSize: '20px', color: '#1976d2' }}></i></span>
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-3">
        <div className="row align-items-center">
          <div className="col-md-6 mb-3">
            <h4 className="page_heading border-bottom-0 mb-0">
              <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.GENERAL_INFORMATION : asiTitle.en.GENERAL_INFORMATION }} />
            </h4>
          </div>
          <div className="col-md-6 text-end mb-3">
            <button
              type="button"
              className="btn btn-success me-2"
              onClick={() => {
                const link = document.createElement('a');
                link.href = 'pdf/sampleSchedule.pdf';
                link.download = 'sampleSchedule.pdf';
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              <i className="fa fa-file-text-o me-1"></i>
              <i className="fa fa-download me-1"></i> Download Schedule Template
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                const input = document.createElement('input');
                input.type = 'file';
                input.accept = '.pdf,.xls,.xlsx';
                input.onchange = (e) => {
                  const file = e.target.files[0];
                  if (file) {
                    // Validate file extension - Only PDF and Excel files allowed
                    const allowedExtensions = ['.pdf', '.xls', '.xlsx'];
                    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

                    if (!allowedExtensions.includes(fileExtension)) {
                      toast.error('Allowed Extensions: .pdf, .xls, .xlsx only', messages.COLOR_RED);
                      return;
                    }

                    // Validate file size (20MB = 20 * 1024 * 1024 bytes)
                    const maxSize = 20 * 1024 * 1024; // 20MB in bytes
                    if (file.size > maxSize) {
                      toast.error('Max Size: 20MB', messages.COLOR_RED);
                      return;
                    }

                    // If validation passes, store the file object and file name
                    setUploadScheduleFile(file);
                    setFormData(prev => ({ ...prev, uploadScheduleFileName: file.name }));
                  }
                };
                input.click();
              }}
            >
              <i className="fa fa-upload me-1"></i>
              Upload Schedule
            </button>
            {formData.uploadScheduleFileName && uploadScheduleFile && (
              <div className="mt-2 position-relative">
                <small className="text-muted">
                  <i className="fa fa-file me-1"></i>
                  Selected file: <strong>{formData.uploadScheduleFileName}</strong>
                </small>
                <button
                  type="button"
                  className="btn btn-sm btn-success position-absolute end-0"
                  style={{
                    top: '50%',
                    transform: 'translateY(-50%)',
                    backgroundColor: '#28a745',
                    borderColor: '#28a745',
                    color: '#fff'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#218838';
                    e.target.style.borderColor = '#1e7e34';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#28a745';
                    e.target.style.borderColor = '#28a745';
                  }}
                  onClick={() => {
                    // Download the uploaded file
                    if (uploadScheduleFile) {
                      const url = window.URL.createObjectURL(uploadScheduleFile);
                      const link = document.createElement('a');
                      link.href = url;
                      link.download = uploadScheduleFile.name;
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                      window.URL.revokeObjectURL(url);
                      toast.success('Schedule file downloaded successfully', messages.COLOR_RED);
                    }
                  }}
                >
                  <i className="fa fa-download me-1"></i>
                  Download
                </button>
              </div>
            )}
          </div>
        </div>
      </div>


      {/* Block A and Block B - Two Column Layout */}
      <div className="mx-3">
        <div className="row">
          {/* Block A - Left Card (Read-only fields) */}
          <div className="col-xl-6 mb-3">
            <div className="card mb-3">
              <div className="card-body">
                <h5 className="card-title mb-4 border-bottom pb-2">Block A</h5>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="w-100" htmlFor="verificationDate">Verification/Compilation Date</label>
                    <input
                      type="text"
                      name="verificationCompilationDate"
                      id="verificationDate"
                      className="form-control"
                      placeholder="DD/MM/YYYY"
                      value={formData.verificationCompilationDate || ''}
                      onChange={handleChange}
                      disabled
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="year">Survey Year</label>
                    <select className="form-select" id="year" name="year" value={formData.year} onChange={handleChange}>
                      <option value="">Select</option>
                      {(() => {
                        const currentDate = new Date();
                        const currentYear = currentDate.getFullYear();
                        const currentMonth = currentDate.getMonth();
                        let currentFinancialYear;
                        if (currentMonth >= 3) {
                          currentFinancialYear = currentYear;
                        } else {
                          currentFinancialYear = currentYear - 1;
                        }
                        const maxYear = currentFinancialYear - 1;
                        const years = [];
                        for (let year = maxYear; year >= 2021; year--) {
                          years.push(
                            <option key={year} value={`${year}-${(year + 1).toString().slice(-2)}`}>
                              {year}-{(year + 1).toString().slice(-2)}
                            </option>
                          );
                        }
                        return years;
                      })()}
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="dslNo"><span className='badge bg-secondary'>1</span> DSL No.</label>
                    <input
                      type="text"
                      name="dslNo"
                      id="dslNo"
                      className="form-control"
                      placeholder="Enter DSL No."
                      maxLength="6"
                      value={formData.dslNo}
                      onChange={handleChange}
                      onBlur={(e) => validateDSL(e.target.value)}
                      disabled={(() => {
                        const userInfo = getUserInfo();
                        return userInfo && userInfo.ROLE_CODE === 'FACTO';
                      })()}
                      style={(() => {
                        const userInfo = getUserInfo();
                        return userInfo && userInfo.ROLE_CODE === 'FACTO'
                          ? { backgroundColor: '#f5f5f5', cursor: 'not-allowed' }
                          : {};
                      })()}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="pslNo"><span className='badge bg-secondary'>2</span> PSL No.</label>
                    <input type="text" className="form-control" id="pslNo" name="pslNo" value={formData.pslNo} onChange={handleChange} disabled />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="schemeCode"><span className='badge bg-secondary'>3</span> Scheme</label>
                    <input type="text" className="form-control" id="schemeCode" name="schemeCode" value={formData.schemeCode} onChange={handleChange} disabled />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="industryCodeFrame"><span className='badge bg-secondary'>4</span> Industry code as per Frame</label>
                    <input type="text" className="form-control" id="industryCodeFrame" name="industryCodeFrame" value={formData.industryCodeFrame} onChange={handleChange} disabled />
                    <small className="text-muted">4-digit level of NIC-08</small>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="industryCodeReturn" id="industryCodeReturn-label"><span className='badge bg-secondary'>5</span> Industry code as per Return</label>
                    <IndustryCodeReturnDropdown
                      options={industryCodeReturnList}
                      value={formData.industryCodeReturn}
                      onChange={handleChange}
                      id="industryCodeReturn"
                      name="industryCodeReturn"
                      placeholder="Select Industry Code"
                    />
                    <small className="text-muted">5-digit level of NIC-08</small>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="descriptionOfIndustry"><span className='badge bg-secondary'>6</span> Description of Industry</label>
                    <textarea
                      ref={descriptionRef}
                      className="form-control description-textarea"
                      id="descriptionOfIndustry"
                      name="descriptionOfIndustry"
                      value={formData.descriptionOfIndustry}
                      onChange={handleChange}
                      disabled
                      rows="3"
                      maxLength={(() => {
                        const is2024Year = !formData.year || formData.year.startsWith('2024');
                        return is2024Year ? 200 : 500;
                      })()}
                      placeholder={(() => {
                        const is2024Year = !formData.year || formData.year.startsWith('2024');
                        return is2024Year ? "Enter description of industry (max 200 characters)" : "Enter description of industry (max 500 characters)";
                      })()}
                      style={{ resize: 'vertical', minHeight: '80px', overflow: 'hidden' }}
                    />
                    <small className="text-muted">
                      {formData.descriptionOfIndustry.length}/{(() => {
                        const is2024Year = !formData.year || formData.year.startsWith('2024');
                        return is2024Year ? 200 : 500;
                      })()} characters
                    </small>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="stateName"><span className='badge bg-secondary'>7</span> State/UT master</label>
                    <input type="text" className="form-control" id="stateName" name="stateName" value={formData.stateName} onChange={handleChange} disabled />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="district"><span className='badge bg-secondary'>8</span> District</label>
                    <input type="text" className="form-control" id="district" name="district" value={formData.district} onChange={handleChange} disabled />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="sector"><span className='badge bg-secondary'>9</span> Sector <span style={{ color: 'red' }}>*</span></label>
                    <select className="form-select" id="sector" name="sector" value={formData.sector} onChange={handleChange}>
                      <option value="">Select</option>
                      <option value="1">Rural</option>
                      <option value="2">Urban</option>
                    </select>
                    <small className="text-muted">For Next Year Frame Updation</small>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="roSroCode"><span className='badge bg-secondary'>10</span> RO / SRO Code</label>
                    <input type="text" className="form-control" id="roSroCode" name="roSroCode" value={formData.roSroCode} onChange={handleChange} disabled />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="numberOfUnits"><span className='badge bg-secondary'>11</span> No. of Units</label>
                    <input type="text" className="form-control" id="numberOfUnits" name="numberOfUnits" value={formData.numberOfUnits} onChange={handleChange} disabled />
                    {/* <small className="text-primary" style={{ cursor: 'pointer' }}>View Joint Units</small> */}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="statusOfUnit" id="statusOfUnit-label"><span className='badge bg-secondary'>12</span> Status of Unit <span style={{ color: 'red' }}>*</span></label>
                    <StatusUnitDropdown
                      options={unitCodes}
                      value={formData.statusOfUnit}
                      onChange={handleChange}
                      id="statusOfUnit"
                      name="statusOfUnit"
                      placeholder="Select"
                    />
                    <small className="text-muted">For Next Year Frame Updation</small>
                  </div>
                </div>

                {/* Upload/Download Supported Documents Section */}
                <div className="row mt-4">
                  <div className="col-12">
                    <h6 className="mb-3">Upload/Download Supported Documents</h6>
                    <div className="d-flex gap-2 mb-2">
                      <input
                        type="text"
                        className="form-control"
                        id="documentPath"
                        name="documentPath"
                        value={formData.documentPath || ''}
                        onChange={handleChange}
                        placeholder="No file selected"
                        readOnly
                      />
                      <button
                        type="button"
                        className="btn btn-outline-primary d-flex align-items-center"
                        style={{ color: '#000' }}
                        onClick={() => {
                          const input = document.createElement('input');
                          input.type = 'file';
                          input.accept = '.pdf,.xls,.xlsx';
                          input.onchange = (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              // Validate file extension
                              const allowedExtensions = ['.pdf', '.xls', '.xlsx'];
                              const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

                              if (!allowedExtensions.includes(fileExtension)) {
                                toast.error('Allowed Extensions: .pdf, .xls, .xlsx', messages.COLOR_RED);
                                return;
                              }

                              // Validate file size (20MB = 20 * 1024 * 1024 bytes)
                              const maxSize = 20 * 1024 * 1024; // 20MB in bytes
                              if (file.size > maxSize) {
                                toast.error('Max Size: 20MB', messages.COLOR_RED);
                                return;
                              }

                              // If validation passes, set the file name and store file object
                              setFormData({ ...formData, documentPath: file.name });
                              setUploadedFile(file); // Store the actual file object
                              toast.success('File selected successfully', messages.COLOR_RED);
                            }
                          };
                          input.click();
                        }}
                      >
                        <i className="fa fa-file-upload me-1"></i>
                        Browse
                      </button>
                      {formData.documentPathFull && (
                        <button
                          type="button"
                          className="btn btn-outline-success d-flex align-items-center"
                          style={{ color: '#000' }}
                          onClick={() => {
                            // Download file from server
                            const filePath = formData.documentPathFull;
                            const downloadUrl = `${API_URL}${filePath}`;

                            // Create a temporary anchor element to trigger download
                            const link = document.createElement('a');
                            link.href = downloadUrl;
                            link.download = formData.documentPath || 'document';
                            link.target = '_blank';

                            // Cookie session or Bearer
                            if (hasAuthSession()) {
                              fetch(downloadUrl, {
                                credentials: 'include',
                                headers: { ...getAuthHeaders().headers },
                              })
                                .then(response => {
                                  if (response.ok) {
                                    return response.blob();
                                  }
                                  throw new Error('Failed to download file');
                                })
                                .then(blob => {
                                  const url = window.URL.createObjectURL(blob);
                                  link.href = url;
                                  document.body.appendChild(link);
                                  link.click();
                                  document.body.removeChild(link);
                                  window.URL.revokeObjectURL(url);
                                  toast.success('File downloaded successfully', messages.COLOR_RED);
                                })
                                .catch(error => {
                                  console.error('Download error:', error);
                                  toast.error('Failed to download file', messages.COLOR_RED);
                                });
                            } else {
                              // If no token, try direct download
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }
                          }}
                        >
                          <i className="fa fa-download me-1"></i>
                          Download
                        </button>
                      )}
                    </div>
                    <small className="text-muted">Allowed Extensions: .pdf, .xls, .xlsx. Max Size: 20MB.</small>
                  </div>
                </div>

              </div>
            </div>
            {/* Remarks Section - Below Block A, same width as Block A */}
                <div className="row">
                  <div className="col-md-12 remarks2-section">
                    <Remarks2
                      remarksData={remarks2Data}
                      setRemarksData={setRemarks2Data}
                      blockOptions={['Block A', 'Block B']}
                      itemOptions={remarks2ItemOptions}
                      remarksList={remarksList}
                    />
                  </div>
                </div>
           
          </div>

          {/* Block B - Right Card (Owner input fields) */}
          <div className="col-xl-6 mb-3">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title mb-4 border-bottom pb-2">Block B</h5>

                <h6 className="mb-2" style={{ fontWeight: 'bold', fontSize: '16px' }}><span class="badge bg-secondary">1</span> Particulars of the factory</h6>
                <p className="text-muted small mb-4">To be filled by owner of the factory</p>
                <div class="card mb-3">
                  <div class="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        {/* Name* */}
                        <div className="mb-3">
                          <label htmlFor="nameUnit">Name<span style={{ color: 'red' }}>*</span></label>
                          <input type="text" className="form-control" id="nameUnit" name="nameUnit" value={formData.nameUnit} onChange={handleChange} maxLength="100" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        {/* Address* */}
                        <div className="mb-3">
                          <label htmlFor="addressUnit">Address<span style={{ color: 'red' }}>*</span></label>
                          <textarea
                            className="form-control"
                            id="addressUnit"
                            name="addressUnit"
                            value={formData.addressUnit}
                            onChange={handleChange}
                            rows="3"
                            maxLength="500"
                            placeholder="Enter address"
                          />
                          <small className="text-muted">
                            <i className="fa fa-info-circle me-1"></i>
                            Address will hold 500 characters
                          </small>
                        </div>
                      </div>
                      <div className="col-md-6">
                        {/* Village / Town* */}
                        <div className="mb-3">
                          <label htmlFor="villTown">Village / Town<span style={{ color: 'red' }}>*</span></label>
                          <input
                            type="text"
                            className="form-control"
                            id="villTown"
                            name="villTown"
                            value={formData.villTown}
                            onChange={handleChange}
                            maxLength="100"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        {/* District Name * */}
                        <div className="mb-3">
                          <label htmlFor="districtName">District Name <span style={{ color: 'red' }}>*</span></label>
                          <select className="form-select" id="districtName" name="districtName" value={formData.districtName} onChange={handleChange}>
                            <option value="">Select District</option>
                            <option value={formData.districtName}>{formData.districtName}</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        {/* State Name */}
                        <div className="mb-3">
                          <label htmlFor="stateName">State Name</label>
                          <input type="text" className="form-control" id="stateName" name="stateName" value={formData.stateName} onChange={handleChange} disabled style={{ backgroundColor: '#f5f5f5' }} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        {/* Pincode * */}
                        <div className="mb-3">
                          <label htmlFor="pinCode">Pincode <span style={{ color: 'red' }}>*</span></label>
                          <input
                            type="text"
                            className="form-control"
                            id="pinCode"
                            name="pinCode"
                            value={formData.pinCode}
                            onChange={handleChange}
                            onBlur={(e) => {
                              const value = e.target.value;
                              if (value && value.trim() !== '') {
                                if (!/^\d{6}$/.test(value.trim())) {
                                  toast.error('Pincode must be 6 digits', messages.COLOR_RED);
                                }
                              }
                            }}
                            maxLength="6"
                            placeholder="Enter 6 digit pin code"
                            pattern="[0-9]*"
                            inputMode="numeric"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        {/* Email Id */}
                        <div className="mb-3">
                          <label htmlFor="emailId">Email Id</label>
                          <input
                            type="email"
                            className="form-control"
                            id="emailId"
                            name="emailId"
                            value={formData.emailId}
                            onChange={handleChange}
                            onBlur={(e) => {
                              const value = e.target.value;
                              if (value && value.trim() !== '') {
                                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                if (!emailRegex.test(value.trim())) {
                                  toast.error('Please enter a valid Email Id', messages.COLOR_RED);
                                }
                              }
                            }}
                            maxLength="100"
                            placeholder="Enter company email"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">

                        {/* Mobile Number * */}
                        <div className="mb-3">
                          <label htmlFor="mobileNumber">Mobile Number <span style={{ color: 'red' }}>*</span></label>
                          <input
                            type="text"
                            className="form-control"
                            id="mobileNumber"
                            name="mobileNumber"
                            value={formData.mobileNumber}
                            onChange={handleChange}
                            onBlur={(e) => {
                              const value = e.target.value;
                              if (value && value.trim() !== '') {
                                if (!/^\d{10}$/.test(value.trim())) {
                                  toast.error('Mobile Number must be 10 digits', messages.COLOR_RED);
                                }
                              }
                            }}
                            maxLength="10"
                            placeholder="Enter Mobile Number"
                            pattern="[0-9]*"
                            inputMode="numeric"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label htmlFor="typeOfOrg"><span class="badge bg-secondary">2</span> Type of organisation<span style={{ color: 'red' }}>*</span></label>
                      <select className="form-select" id="typeOfOrg" name="typeOfOrg" value={formData.typeOfOrg} onChange={handleChange}>
                        <option value="">Select Organization</option>
                        <option value="1">Individual Proprietorship</option>
                        <option value="2">Partnership</option>
                        <option value="3">Limited Liability Partnership</option>
                        <option value="4">Government Company - Public</option>
                        <option value="5">Government Company - Private</option>
                        <option value="6">Non-Government Company - Public</option>
                        <option value="7">Non-Government Company - Private</option>
                        <option value="8">Co-operative Society</option>
                        <option value="9">Others (including Joint Family (HUF), Trust)</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label htmlFor="cin"><span class="badge bg-secondary">3</span> CIN</label>
                      <input
                        type="text"
                        className="form-control"
                        id="cin"
                        name="cin"
                        value={formData.cin}
                        onChange={handleChange}
                        maxLength="25"
                        disabled
                        style={{ backgroundColor: '#f5f5f5' }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label htmlFor="isoCert"><span class="badge bg-secondary">4</span> Whether the unit has ISO Certification, 14000 Series<span style={{ color: 'red' }}>*</span></label>
                      <select className="form-select" id="isoCert" name="isoCert" value={formData.isoCert} onChange={handleChange}>
                        <option value="">Select</option>
                        <option value="1">Yes</option>
                        <option value="2">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label htmlFor="yearOfInitialProd"><span class="badge bg-secondary">5</span> Year of initial production<span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        id="yearOfInitialProd"
                        name="yearOfInitialProd"
                        value={formData.yearOfInitialProd}
                        onChange={handleChange}
                        maxLength="4"
                        placeholder="Select Year"
                        pattern="[0-9]*"
                        inputMode="numeric"
                      />
                      <small className="text-muted">FORMAT "YYYY"</small>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label htmlFor="accountingYear"><span class="badge bg-secondary">6</span> Accounting Year<span style={{ color: 'red' }}>*</span></label>
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="text"
                          className="form-control"
                          id="accountingYearFrom"
                          name="accountingYearFrom"
                          value={formData.accountingYearFrom}
                          onChange={handleChange}
                          maxLength="5"
                          placeholder="MM/YY"
                          pattern="[0-9/]*"
                        />
                        <span>To</span>
                        <input
                          type="text"
                          className="form-control"
                          id="accountingYearTo"
                          name="accountingYearTo"
                          value={formData.accountingYearTo}
                          onChange={handleChange}
                          maxLength="5"
                          placeholder="MM/YY"
                          pattern="[0-9/]*"
                        />
                      </div>
                      <small className="text-muted">FORMAT "(MM/YY)"</small>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label htmlFor="monthsOfOperation"><span class="badge bg-secondary">7</span> No of months operation<span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        id="monthsOfOperation"
                        name="monthsOfOperation"
                        value={formData.monthsOfOperation}
                        onChange={handleChange}
                        maxLength="2"
                        pattern="[0-9]*"
                        inputMode="numeric"
                      />
                    </div>
                  </div>
                  <div className="col-12 mb-3">
                    <label htmlFor="shareCapital"><span class="badge bg-secondary">8</span> Whether the share capital of the company includes share of foreign entities (Yes-1, No-2)</label>
                    <select className="form-select" id="shareCapital" name="shareCapital" value={formData.shareCapital} onChange={handleChange}>
                      <option value="" disabled>Select</option>
                      <option value="1">Yes</option>
                      <option value="2">No</option>
                    </select>
                  </div>
                  <div className="col-12 mb-3">
                    <label htmlFor="rdUnit"><span className="badge bg-secondary">9</span> Any RD unit in your factory (Yes registered with DST/DBT-1, Yes registered with others-2, no-3)</label>
                    <select className="form-select" id="rdUnit" name="rdUnit" value={formData.rdUnit} onChange={handleChange}>
                      <option value="" disabled>Select</option>
                      <option value="1">Yes registered with DST/DBT-1</option>
                      <option value="2">Yes registered with others-2</option>
                      <option value="3">No-3</option>
                    </select>
                    <small className="text-muted"><i className="fa fa-info-circle me-1"></i>If yes & registered with DSIR- 1 or yes & registered with other - 2 in item no. 9. number of employees engaged in R&D activity</small>
                  </div>
                  {(formData.rdUnit === '1' || formData.rdUnit === '2') && (
                    <>
                      <div className="col-md-4 mb-3">
                        <label>Male</label>
                        <input type="text" className="form-control" name="rdMaleEmployees" maxLength="100" value={formData.rdMaleEmployees ?? ''} onChange={handleChange} />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label>Female</label>
                        <input type="text" className="form-control" name="rdFemaleEmployees" maxLength="100" value={formData.rdFemaleEmployees ?? ''} onChange={handleChange} />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label>Transgender</label>
                        <input type="text" className="form-control" name="rdTransgenderEmployees" maxLength="100" value={formData.rdTransgenderEmployees ?? ''} onChange={handleChange} />
                      </div>
                    </>
                  )}
                  <div className="col-12 mb-3">
                    <h6 className="mb-2" style={{ fontWeight: 'bold', fontSize: '16px' }}><span class="badge bg-secondary">10</span> Details of contact person</h6>
                  </div>

                </div>
                <div class="card mb-3">
                  <div class="card-body">
                    <div className="row">

                      {/* For 2024-2025: Show separate fields */}
                      {(() => {
                        const is2024Year = !formData.year || formData.year.startsWith('2024');
                        if (is2024Year) {
                          return (
                            <>
                              <div className="col-md-6 mb-3">
                                <label>Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Contact person name"
                                  name="contactPersonName"
                                  value={formData.contactPersonName}
                                  onChange={handleChange}
                                  maxLength="100"
                                />
                              </div>
                              <div className="col-md-6 mb-3">
                                <label>Designation</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Designation"
                                  name="contactPersonDesignation"
                                  value={formData.contactPersonDesignation}
                                  onChange={handleChange}
                                  maxLength="100"
                                />
                              </div>
                              <div className="col-md-6 mb-3">
                                <label>Email Id</label>
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="Email address"
                                  name="contactPersonEmail"
                                  value={formData.contactPersonEmail}
                                  onChange={handleChange}
                                  maxLength="100"
                                  onBlur={(e) => {
                                    const value = e.target.value;
                                    if (value && value.trim() !== '') {
                                      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                      if (!emailRegex.test(value.trim())) {
                                        toast.dismiss();
                                        toast.error('Please enter a valid Email Id', messages.COLOR_RED);
                                      }
                                    }
                                  }}
                                />
                              </div>
                              <div className="col-md-6 mb-3">
                                <label>Mobile Number</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Mobile number"
                                  name="contactPersonMobile"
                                  value={formData.contactPersonMobile}
                                  onChange={handleChange}
                                  maxLength="10"
                                  pattern="[0-9]*"
                                  inputMode="numeric"
                                  onBlur={(e) => {
                                    const value = e.target.value;
                                    if (value && value.trim() !== '') {
                                      if (!/^\d{10}$/.test(value.trim())) {
                                        toast.dismiss();
                                        toast.error('Mobile Number must be 10 digits', messages.COLOR_RED);
                                      }
                                    }
                                  }}
                                />
                              </div>
                            </>
                          );
                        } else {
                          return (
                            <>
                              <div className="col-md-6 mb-3">
                                <label>Name and Designation</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="contactName"
                                  value={formData.contactName}
                                  onChange={handleChange}
                                  maxLength="100"
                                  pattern="[a-zA-Z\s\.\-]+"
                                  title="Only letters, spaces, dots, and hyphens are allowed"
                                />
                              </div>
                              <div className="col-md-6 mb-3">
                                <label>Tele (With STD Code)</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="+91-123-456-7890"
                                  name="contactTele"
                                  value={formData.contactTele}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const allowedPattern = /^[+\d-]*$/;
                                    if (allowedPattern.test(value) || value === '') {
                                      const cleanedValue = value.replace(/[-]+/g, '-');
                                      setFormData({ ...formData, contactTele: cleanedValue });
                                    } else {
                                      toast.error('Only numbers, + and -  are allowed', messages.COLOR_RED);
                                    }
                                  }}
                                  onBlur={(e) => {
                                    const value = e.target.value;
                                    if (value && value.trim() !== '') {
                                      const digitCount = (value.match(/\d/g) || []).length;
                                      if (digitCount < 10) {
                                        toast.error('Phone number Should be 10 digits Only', messages.COLOR_RED);
                                      }
                                    }
                                  }}
                                  maxLength="13"
                                />
                              </div>
                            </>
                          );
                        }
                      })()}

                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mb-3">
                    <label htmlFor="formalTraining"><span class="badge bg-secondary">11</span> Whether the unit offered any formal training?</label>
                    <select className="form-select" id="formalTraining" name="formalTraining" value={formData.formalTraining} onChange={handleChange}>
                      <option value="" disabled>Select</option>
                      <option value="1">Yes</option>
                      <option value="2">No</option>
                    </select>
                  </div>
                  {/* Training Employee counts - Show only for 2024-2025 when Training is Yes (1) */}
                  {(() => {
                    const is2024Year = !formData.year || formData.year.startsWith('2024');
                    const showTrainingEmployees = is2024Year && formData.formalTraining === '1';

                    if (showTrainingEmployees) {
                      return (
                        <>
                          <div className="col-12 mb-2 mt-2">
                          <small class="text-muted"><i class="fa fa-info-circle me-1"></i>If yes, number of employees received formal training</small>
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="trainingMaleEmployees">11.1 Male</label>
                            <input
                              type="text"
                              className="form-control"
                              id="trainingMaleEmployees"
                              name="trainingMaleEmployees"
                              maxLength="6"
                              value={formData.trainingMaleEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="trainingFemaleEmployees">11.2 Female</label>
                            <input
                              type="text"
                              className="form-control"
                              id="trainingFemaleEmployees"
                              name="trainingFemaleEmployees"
                              maxLength="6"
                              value={formData.trainingFemaleEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="trainingTransgenderEmployees">11.3 Transgender</label>
                            <input
                              type="text"
                              className="form-control"
                              id="trainingTransgenderEmployees"
                              name="trainingTransgenderEmployees"
                              maxLength="6"
                              value={formData.trainingTransgenderEmployees}
                              onChange={handleChange}
                              placeholder="Number of employees"
                            />
                          </div>
                        </>
                      );
                    }
                    return null;
                  })()}
                  {/* GSTIN - Show only for 2024-2025 */}
                  {(() => {
                    const is2024Year = !formData.year || formData.year.startsWith('2024');
                    if (is2024Year) {
                      return (
                        <div className="col-12 mb-3">
                          <label htmlFor="gstin"><span class="badge bg-secondary">12</span> Goods and Services Tax Identification Number (GSTIN)</label>
                          <input
                            type="text"
                            className="form-control"
                            id="gstin"
                            name="gstin"
                            maxLength="15"
                            value={formData.gstin}
                            onChange={handleChange}
                            placeholder="GSTIN (15 characters)"
                          />
                        </div>
                      );
                    }
                    return null;
                  })()}
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <div className="mx-3">
        <div className="row">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => window.print()}
            >
              Print
              <i className="fa fa-print ms-1"></i>
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={async () => {
                if (buttonClickRef.current.isProcessing) {
                  return;
                }
                buttonClickRef.current.isProcessing = true;

                if (!validateDSLMandatory()) {
                  buttonClickRef.current.isProcessing = false;
                  return;
                }
                if (!validateDateRange()) {
                  buttonClickRef.current.isProcessing = false;
                  return;
                }

                try {
                  const saveSuccess = await handleSaveCompleteAsiFrame();
                  if (saveSuccess) {
                    const statusCode = String(formData.statusOfUnit || '').trim();
                    const surveyYearStr = String(formData.year || '').trim();
                    const isSkipBlocksStatus = ['4', '5', '7', '8'].includes(statusCode);
                    const is2024Year = surveyYearStr === '2024' || surveyYearStr.startsWith('2024');

                    if (isSkipBlocksStatus && is2024Year) {
                      try {
                        showLoading(true);
                        const yearOnly = surveyYearStr.split('-')[0] || surveyYearStr;
                        const blocks = getStaticBlockPayload(formData.dslNo, yearOnly);
                        const config = { ...getAuthHeaders(), withCredentials: true };
                        const failed = [];
                        for (let i = 0; i < blocks.length; i++) {
                          try {
                            const res = await axios.post(`${API_URL}api/${blocks[i].apiPath}`, blocks[i].payload, config);
                            if (!res.data || !res.data.status) {
                              failed.push(blocks[i].apiPath);
                              console.warn('Static save block failed (no status):', blocks[i].apiPath, res.data);
                            }
                          } catch (blockErr) {
                            failed.push(blocks[i].apiPath);
                            console.warn('Static save block error:', blocks[i].apiPath, blockErr.response?.data || blockErr.message);
                          }
                        }
                        if (failed.length > 0) {
                          toast.warning(`Some blocks could not be saved: ${failed.join(', ')}. You can fill them later.`, messages.COLOR_RED);
                        }
                        localStorage.setItem('balanceSheetAccessPageIds', JSON.stringify([1, 11]));
                        localStorage.setItem('balanceSheetApiCalled', 'true');
                        window.dispatchEvent(new CustomEvent('balanceSheetValidationUpdated', { detail: [1, 11] }));
                      } catch (err) {
                        console.error('Save static blocks error:', err);
                        toast.error('Error saving block data. Please try again.', messages.COLOR_RED);
                      } finally {
                        showLoading(false);
                      }
                    }
                  }
                } finally {
                  buttonClickRef.current.isProcessing = false;
                }
              }}
            >
              Save
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={handleReset}
            >
              Reset
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => window.location.href = '/dashboard'}
            >
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={async () => {
                if (buttonClickRef.current.isProcessing) {
                  return;
                }
                buttonClickRef.current.isProcessing = true;

                if (!validateDSLMandatory()) {
                  buttonClickRef.current.isProcessing = false;
                  return;
                }

                if (!validateDateRange()) {
                  buttonClickRef.current.isProcessing = false;
                  return;
                }

                const emailError = validateEmail(formData.contactEmail);
                if (emailError) {
                  setErrors(prev => ({ ...prev, contactEmail: emailError }));
                  const toastKey = 'next-email-error';
                  if (!toastShownRef.current[toastKey]) {
                    toast.error(emailError, messages.COLOR_RED);
                    toastShownRef.current[toastKey] = true;
                    setTimeout(() => delete toastShownRef.current[toastKey], 3000);
                  }
                  buttonClickRef.current.isProcessing = false;
                  return;
                }


                const saveSuccess = await handleSaveCompleteAsiFrame();

                if (saveSuccess) {
                  const statusCode = String(formData.statusOfUnit || '').trim();
                  const surveyYearStr = String(formData.year || '').trim();
                  const isSkipBlocksStatus = ['4', '5', '7', '8'].includes(statusCode);
                  const is2024Year = surveyYearStr === '2024' || surveyYearStr.startsWith('2024');

                  if (isSkipBlocksStatus && is2024Year) {
                    try {
                      showLoading(true);
                      const yearOnly = surveyYearStr.split('-')[0] || surveyYearStr;
                      const blocks = getStaticBlockPayload(formData.dslNo, yearOnly);
                      const config = { ...getAuthHeaders(), withCredentials: true };
                      const failed = [];
                      for (let i = 0; i < blocks.length; i++) {
                        try {
                          const res = await axios.post(`${API_URL}api/${blocks[i].apiPath}`, blocks[i].payload, config);
                          if (!res.data || !res.data.status) {
                            failed.push(blocks[i].apiPath);
                            console.warn('Static save block failed (no status):', blocks[i].apiPath, res.data);
                          }
                        } catch (blockErr) {
                          failed.push(blocks[i].apiPath);
                          console.warn('Static save block error:', blocks[i].apiPath, blockErr.response?.data || blockErr.message);
                        }
                      }
                      if (failed.length > 0) {
                        console.warn('Static save failed for:', failed.join(', '));
                        toast.warning(`Some blocks could not be saved: ${failed.join(', ')}. You can fill them later.`, messages.COLOR_RED);
                      }
                      localStorage.setItem('balanceSheetAccessPageIds', JSON.stringify([1, 11]));
                      localStorage.setItem('balanceSheetApiCalled', 'true');
                      window.dispatchEvent(new CustomEvent('balanceSheetValidationUpdated', { detail: [1, 11] }));
                      setTimeout(() => navigate('/net-profit-tally'), 500);
                    } catch (err) {
                      console.error('Save static blocks error:', err);
                      toast.error('Error saving block data. Please try again.', messages.COLOR_RED);
                      buttonClickRef.current.isProcessing = false;
                    } finally {
                      showLoading(false);
                    }
                  } else {
                    setTimeout(() => navigate('/fixedAssets'), 1500);
                  }
                } else {
                  buttonClickRef.current.isProcessing = false;
                }
              }}
            >
              Next
              <i className="fa fa-angle-right ms-1"></i>
            </button>
          </div>
        </div>
      </div>
      <div className='mx-3'>
        <Remarks__list
          hideColumnsColumn
          remarksData={useMemo(() => {
            const remarksData = {
              remarksBlock: normalizeRemarksBlockForApi(formData.remarksBlock) || '',
              remarksItems: normalizeRemarksItemForApi(formData.remarksItems) || ''
            };
            return filterRemarksList(remarksList, remarksData);
          }, [remarksList, formData.remarksBlock, formData.remarksItems, normalizeRemarksBlockForApi, normalizeRemarksItemForApi])}
        />
      </div>
    </>
  );
}

export default BalanceSheet;
